import type { Clave } from "./es";

/**
 * El programa en neerlandés, por los socios holandeses y belgas, que en Barcelona son muchos.
 *
 * `Record<Clave, string>` es lo que hace que no se pueda olvidar ninguna
 * frase: si es.ts gana una clave y aquí no está, el programa no compila. Es
 * mejor que una prueba, porque salta antes de ejecutar nada.
 */
export const nl: Record<Clave, string> = {
  "general.cargando": "Laden...",
  "general.unMomento": "Momentje...",
  "general.guardando": "Bezig met opslaan...",
  "general.guardar": "Opslaan",
  "general.guardado": "Opgeslagen",
  "general.cancelar": "Annuleren",
  "general.cerrar": "Sluiten",
  "general.volver": "Terug",
  "general.salir": "Uitloggen",
  "general.entrar": "Inloggen",
  "general.enviando": "Bezig met versturen...",
  "general.idioma": "Taal",
  "general.o": "of",
  "general.fallo": "De actie kon niet worden voltooid",

  "titulo.gestion": "Clubbeheer",
  "titulo.portal": "Mijn club",
  "titulo.carta": "Prijsbord",
  "titulo.plataforma": "Platformbeheer",
  "titulo.web": "asocis · Beheer van cannabisverenigingen",
  "titulo.prueba": "Proef aanvragen · asocis",
  "manifiesto.nombre": "Ledenportaal",
  "manifiesto.descripcion":
    "Je pas, je verbruik, je contributie en het nieuws van je vereniging.",
  "carta.cargando": "Het prijsbord laden…",
  "carta.noDisponible": "Prijsbord niet beschikbaar",
  "carta.noDisponibleAyuda":
    "Controleer de link, of vraag de club het prijsbord aan te zetten bij de instellingen.",
  "carta.sinProducto": "Er is nu niets beschikbaar.",
  "carta.pie": "Solidariteitsbijdrage voor leden · Bijgewerkt om {hora}",
  "carta.pieSinConexion":
    "Solidariteitsbijdrage voor leden · Bijgewerkt om {hora} · geen verbinding, kan verouderd zijn",
  "unidad.dia": "dag",
  "unidad.dias": "dagen",

  "mov.recarga.EFECTIVO": "Opwaardering contant",
  "mov.recarga.TARJETA": "Opwaardering pin",
  "mov.recarga.TRANSFERENCIA": "Opwaardering overboeking",
  "mov.devolucion": "Saldo terugbetaald",
  "mov.dispensacion": "Verstrekking #{numero}",
  "mov.dispensacionAnulada": "Verstrekking #{numero} geannuleerd",
  "mov.barra": "Bar #{numero}",
  "mov.barraAnulada": "Bar #{numero} geannuleerd",
  "mov.donacion": "Donatie aan de club",
  "cuota.anual": "Jaarcontributie",
  "cuota.anios": "Contributie voor {n} jaar",
  "cuota.unMes": "Contributie voor één maand",
  "cuota.meses": "Contributie voor {n} maanden",
  "cuota.alta": "Inschrijfgeld",
  "pago.EFECTIVO": "Contant",
  "pago.CARTERA": "Tegoed",
  "pago.TARJETA": "Pin",
  "pago.TRANSFERENCIA": "Overboeking",
  "movimiento.RECARGA": "Opwaardering",
  "movimiento.CONSUMO": "Besteding",
  "movimiento.DEVOLUCION": "Terugbetaling",
  "movimiento.AJUSTE": "Correctie",
  "movimiento.CUOTA": "Contributie",
  "genetica.SATIVA": "sativa",
  "genetica.INDICA": "indica",
  "genetica.HIBRIDA": "hybride",
  "genetica.CBD": "CBD",
  "genetica.NA": "—",

  "portal.cabecera.socioNumero": "{nombre} · lid nr. {numero}",
  "portal.cabecera.contrasena": "Wachtwoord",
  "portal.pestana.inicio": "Mijn ledenpas",
  "portal.pestana.catalogo": "Beschikbaar",
  "portal.pestana.reservas": "Mijn reserveringen",
  "portal.pestana.noticias": "Nieuws",
  "portal.pestana.valoraciones": "Beoordelen",
  "portal.pestana.historial": "Mijn historie",
  "portal.pestana.contrato": "Contract",

  "entrada.titulo": "Ledenportaal",
  "entrada.subtituloEntrar": "Bekijk je verbruik, je contributie en je ledenpas",
  "entrada.subtituloActivar": "Activeer je toegang met de code van de club",
  "entrada.club": "Club",
  "entrada.clubAyuda": "De clubcode die je van de vereniging hebt gekregen.",
  "entrada.numeroSocio": "Lidnummer",
  "entrada.codigo": "Activatiecode",
  "entrada.codigoAyuda": "Je krijgt hem aan de balie. Hij verloopt na 7 dagen.",
  "entrada.contrasena": "Wachtwoord",
  "entrada.eligeContrasena": "Kies een wachtwoord",
  "entrada.minimo8": "Minimaal 8 tekens.",
  "entrada.repiteContrasena": "Herhaal het wachtwoord",
  "entrada.crearAcceso": "Mijn toegang aanmaken",
  "entrada.primeraVez": "Eerste keer?",
  "entrada.activarAcceso": "Mijn toegang activeren",
  "entrada.yaTengoContrasena": "Ik heb al een wachtwoord",
  "entrada.noCoinciden": "De twee wachtwoorden komen niet overeen",
  "entrada.accesoCreado": "Toegang aangemaakt. Je kunt nu inloggen met je wachtwoord.",

  "inicio.cuotaVencioHace": "Je lidmaatschap is {dias} geleden verlopen. Kom langs bij de club om het te verlengen.",
  "inicio.cuotaVenceHoy": "Je lidmaatschap verloopt vandaag.",
  "inicio.cuotaVenceEn": "Je lidmaatschap verloopt over {dias}.",
  "inicio.socio": "Lid",
  "inicio.numero": "Nr. {numero}",
  "inicio.socioDesde": "Lid sinds {fecha}",
  "inicio.cuotaValidaHasta": "Lidmaatschap geldig tot {fecha}",
  "inicio.generando": "Bezig met genereren…",
  "inicio.ensenaCodigo": "Laat deze code aan de balie zien om je te identificeren.",
  "inicio.tuConsumo": "Je verbruik",
  "inicio.hoy": "Vandaag",
  "inicio.esteMes": "Deze maand",
  "inicio.puedesRetirar": "Je kunt nu afhalen",
  "inicio.tuCartera": "Je tegoed",
  "inicio.saldoDisponible": "Beschikbaar saldo voor je bijdragen. Opwaarderen doe je aan de balie.",
  "inicio.tuClub": "Je club",
  "inicio.telefono": "Telefoon:",

  "avisos.titulo": "Meldingen van de club",
  "avisos.noSoportado":
    "Deze browser ondersteunt geen meldingen. Je kunt het nieuws bekijken door in te loggen op het portaal.",
  "avisos.requiereInstalar1": "Op de iPhone moet je het portaal eerst aan je beginscherm toevoegen: tik op",
  "avisos.compartir": "Delen",
  "avisos.yLuego": "en daarna",
  "avisos.anadirAInicio": "Zet op beginscherm",
  "avisos.requiereInstalar2": "Daarna kun je de meldingen hier aanzetten.",
  "avisos.activados": "Je krijgt een melding op dit apparaat als de club nieuws plaatst.",
  "avisos.sinActivar": "Zet meldingen aan om het nieuws van de club te zien zonder in te loggen.",
  "avisos.desactivar": "Meldingen uitzetten",
  "avisos.activar": "Meldingen aanzetten",
  "avisos.enviarPrueba": "Testmelding sturen",
  "avisos.yaNo": "Je krijgt geen meldingen meer op dit apparaat.",
  "avisos.listo": "Klaar. We laten het je weten als de club iets plaatst.",
  "avisos.bloqueados":
    "Je browser blokkeert de meldingen voor deze pagina. Je kunt ze in de instellingen van de browser weer toestaan.",
  "avisos.fallo": "De meldingen konden niet worden aangezet. Probeer het later opnieuw.",
  "avisos.pruebaEnviada": "Testmelding verstuurd: die zou binnen een paar seconden moeten aankomen.",
  "avisos.pruebaFallo": "De testmelding kon niet worden verstuurd.",

  "catalogo.vacio": "De club heeft op dit moment geen producten gepubliceerd.",
  "catalogo.condiciones":
    "In de bijdragen zijn jouw voorwaarden als lid al verwerkt. De beschikbaarheid kan in de loop van de dag veranderen.",
  "catalogo.sinSaldo":
    "Om te reserveren heb je saldo op je tegoed nodig. Kom langs bij de club om het op te waarderen, dan kun je hier bestellen.",
  "catalogo.sinStock": "Geen voorraad",
  "catalogo.quitarGramo": "Een gram eraf",
  "catalogo.anadirGramo": "Een gram erbij",
  "catalogo.faltan": "Je komt {importe} tekort op je tegoed",
  "catalogo.quedarian": "Er blijft dan {importe} over op je tegoed",
  "catalogo.vaciar": "Leegmaken",
  "catalogo.reservar": "Reserveren",
  "catalogo.reservando": "Bezig met reserveren...",
  "catalogo.falloReserva": "De reservering kon niet worden gemaakt",
  "reservas.vacio":
    "Je hebt nog niets gereserveerd. Via «Beschikbaar» kun je bestellen wat je wilt en het daarna ophalen.",
  "reservas.titulo": "Reservering {numero}",
  "reservas.PENDIENTE": "In afwachting",
  "reservas.PENDIENTE.explica": "De club heeft hem nog niet klaargemaakt.",
  "reservas.PREPARADA": "Klaar",
  "reservas.PREPARADA.explica": "Hij ligt klaar. Kom hem ophalen.",
  "reservas.ENTREGADA": "Verstrekt",
  "reservas.ENTREGADA.explica": "Opgehaald.",
  "reservas.CANCELADA": "Geannuleerd",
  "reservas.CADUCADA": "Verlopen",
  "reservas.CADUCADA.explica": "De termijn is verstreken zonder dat je hem hebt opgehaald.",
  "reservas.total": "Totaal {cantidad}",
  "reservas.guardadaHasta": "Bewaard tot {fecha}. Daarna wordt de reservering vanzelf geannuleerd.",
  "reservas.falloCancelar": "Annuleren is niet gelukt",

  "noticias.vacio": "De club heeft nog niets geplaatst.",

  "valoraciones.vacio":
    "Zodra je iets hebt afgehaald, kun je hier zeggen wat je ervan vond. Zo weet de club wat hij opnieuw moet inkopen.",
  "valoraciones.intro":
    "Zeg wat je vond van wat je hebt afgehaald. De club leest het, om te weten wat hij opnieuw inkoopt.",
  "valoraciones.nDe5": "{n} van 5",
  "valoraciones.comentario": "Iets wat je kwijt wilt (optioneel)",

  "historial.retiradas": "Wat je hebt afgehaald",
  "historial.sinRetiradas": "Je hebt nog niets afgehaald.",
  "historial.fecha": "Datum",
  "historial.productos": "Producten",
  "historial.cantidad": "Hoeveelheid",
  "historial.aportacion": "Bijdrage",
  "historial.anulada": "Geannuleerd",
  "historial.cartera": "Mutaties van je tegoed",
  "historial.sinMovimientos": "Geen mutaties.",
  "historial.concepto": "Omschrijving",
  "historial.importe": "Bedrag",
  "historial.saldo": "Saldo",
  "historial.cuotas": "Je contributies",
  "historial.sinCuotas": "Geen contributies geregistreerd.",
  "historial.validaHasta": "Lid tot",

  "contrato.sinPublicar": "Je vereniging heeft haar ledencontract hier nog niet gepubliceerd.",
  "contrato.aceptaste": "Je hebt",
  "contrato.version": "versie {numero}",
  "contrato.elDia": "op {fecha}",
  "contrato.esLaQueAplica": "geaccepteerd. Die geldt voor jou.",
  "contrato.leeConCalma":
    "Lees het rustig door. Als je het accepteert, worden de datum en de versie vastgelegd, en je kunt het hier altijd teruglezen.",
  "contrato.versionNueva":
    "De vereniging heeft een nieuwere versie gepubliceerd. Wat je hebt ondertekend, is nog steeds de versie hierboven; vraag in de club als je de nieuwe wilt accepteren.",
  "contrato.aceptar": "Ik heb het contract gelezen en ga ermee akkoord",
  "contrato.falloGuardar": "Opslaan is niet gelukt",

  "contrasena.titulo": "Mijn wachtwoord wijzigen",
  "contrasena.actual": "Huidig wachtwoord",
  "contrasena.nueva": "Nieuw wachtwoord",
  "contrasena.repite": "Herhaal het nieuwe",
  "contrasena.cambiar": "Wijzigen",
  "contrasena.cambiada": "Wachtwoord gewijzigd.",
  "contrasena.fallo": "Het wachtwoord kon niet worden gewijzigd",

  "alta.titulo": "Inschrijving aanvragen",
  "alta.clubNoEncontrado": "We kunnen die club niet vinden. Controleer de link die je hebt gekregen.",
  "alta.nombre": "Voornaam *",
  "alta.apellidos": "Achternaam *",
  "alta.documento": "Identiteitsbewijs",
  "alta.pasaporte": "Paspoort",
  "alta.numero": "Nummer *",
  "alta.fechaNacimiento": "Geboortedatum *",
  "alta.mayorDeEdad": "Je moet 18 jaar of ouder zijn.",
  "alta.telefono": "Telefoon",
  "alta.email": "E-mail",
  "alta.ciudad": "Plaats",
  "alta.avalista": "Lidnummer van het lid dat jou voordraagt",
  "alta.avalistaAyuda": "Als iemand van de vereniging jou voordraagt.",
  "alta.mensaje": "Bericht voor de club",
  "alta.consentimiento":
    "Ik geef de vereniging toestemming om mijn gegevens te verwerken om deze aanvraag te beoordelen.",
  "alta.consentimientoAyuda":
    "Als de aanvraag wordt afgewezen, blijven je gegevens alleen in hun interne registratie staan.",
  "alta.enviar": "Aanvraag versturen",
  "alta.yaSoySocio": "Ik ben al lid",
  "alta.enviada": "Aanvraag verstuurd",
  "alta.enviadaTexto":
    "{club} bekijkt de aanvraag en neemt contact met je op. Denk eraan dat de inschrijving in de club wordt afgerond, waarbij je je identiteitsbewijs laat zien.",
  "alta.elClub": "De club",
  "alta.fallo": "De aanvraag kon niet worden verstuurd",

  "err.clubNoEncontrado": "We kunnen die club niet vinden",
  "err.codigoNoValido": "Lidnummer of activatiecode klopt niet, of de code is verlopen",
  "err.entradaIncorrecta": "Lidnummer of wachtwoord klopt niet",
  "err.passwordActualMal": "Je huidige wachtwoord klopt niet",
  "err.soloLoQueTeLlevaste": "Je kunt alleen beoordelen wat je hebt afgehaald",
  "err.sinContrato": "Deze club heeft nog geen ledencontract",
  "err.reservaNoEncontrada": "We kunnen die reservering niet vinden",
  "err.reservaNoPendiente": "Deze reservering staat niet meer in afwachting",
  "err.reservaCerrada": "Deze reservering is al afgesloten",
  "err.yaTienesReserva":
    "Je hebt reservering {numero} nog niet opgehaald. Annuleer die als je iets anders wilt bestellen.",
  "err.productoNoEncontrado": "We kunnen dat product niet vinden",
  "err.pasaDelMes": "Dit is meer dan je deze maand nog mag afhalen. Je hebt nog {cantidad}.",
  "err.sinSaldo":
    "Om te reserveren heb je saldo op je tegoed nodig: dit kost {total} en je hebt {saldo}. Opwaarderen doe je aan de balie.",
  "err.mayorDeEdad": "Je moet 18 jaar of ouder zijn",
  "err.nacimientoNoValido": "Die geboortedatum is niet geldig",
  "err.consentimiento": "Vink de toestemming voor het verwerken van je gegevens aan",
  "err.idiomaNoExiste": "Die taal bestaat niet",
  "err.bloqueo.baja": "Je bent uitgeschreven. Neem contact op met de club.",
  "err.bloqueo.suspendido": "Je inschrijving is geschorst. Neem contact op met de club.",
  "err.bloqueo.pendiente":
    "Je inschrijving moet nog worden goedgekeurd. Kom langs bij de club om die af te ronden.",
  "err.bloqueo.cuotaCaducada":
    "Je lidmaatschap is verlopen. Kom langs bij de club om het te verlengen.",
  "err.bloqueo.cuotaVencida":
    "Je lidmaatschap is verlopen en moet worden verlengd. Kom langs bij de club.",
  "servidor.El socio está dado de baja": "Het lid is uitgeschreven",
  "servidor.El socio está suspendido": "Het lid is geschorst",
  "servidor.El alta del socio está pendiente de validar": "De inschrijving van dit lid moet nog worden goedgekeurd",
  "servidor.La cuota del socio está caducada": "Het lidmaatschap van dit lid is verlopen",
  "servidor.La cuota del socio ha caducado: hay que renovarla":
    "Het lidmaatschap van dit lid is verlopen: het moet worden verlengd",

  "web.entrar": "Inloggen",
  "web.frase":
    "asocis is het programma om een cannabisvereniging te runnen: leden, balie, voorraadbeheer per partij, kassa en ledenportaal.",
  "web.fraseSegunda":
    "Hieronder zie je de balie, die op verzonnen gegevens draait. Kies een lid, tik producten aan, ga over de limiet heen, reken af.",
  "web.altasUnaAUna": "Nieuwe clubs gaan één voor één: je krijgt een code en daarmee zet je je club in een minuut op.",
  "web.yaTienesUno": "Heb je er al een?",
  "web.pedirPrueba": "Proef aanvragen",
  "web.pedirAcceso": "Toegang aanvragen",
  "web.probarGratis": "{dias} gratis uitproberen",
  "web.crearClub": "Mijn club aanmaken",
  "web.pieDemo":
    "Met jouw gegevens doet het precies hetzelfde. Wat hier niet in past: het zoeken op naam, nummer of identiteitsbewijs; de QR-lezer van de ledenpas; de categorieën van de catalogus; de kortingen met de hand; en de rest van het menu.",

  "web.detras": "Wat er achter de balie zit",
  "web.detras.socios": "Leden",
  "web.detras.socios.texto":
    "Inschrijving met identiteitsbewijs, foto, voordragend lid, opgegeven verbruik en toestemming met datum. Lidmaatschapsvormen met hun contributie, hun korting en hun limieten. Het ledenregister dat de vereniging verplicht moet bijhouden, klaar om af te drukken. En «CSV importeren» om ze uit je vorige programma over te zetten.",
  "web.detras.limites": "Limieten",
  "web.detras.limites.texto":
    "Elk lid heeft een daglimiet en een maandlimiet. De balie vergelijkt de bestelling met wat het lid al heeft gehad; gaat het eroverheen, dan moet iemand het toestaan en wordt vastgelegd wie dat deed. Een lid met een verlopen lidmaatschap krijgt niets verstrekt tot het verlengd is.",
  "web.detras.inventario": "Voorraadbeheer per partij",
  "web.detras.inventario.texto":
    "Ontvangsten gaan per partij, met leverancier, kostprijs en houdbaarheidsdatum. De balie haalt van de oudste partij af, derving krijgt een reden en tellingen vergelijken wat er geteld is met wat er zou moeten zijn. Van elke verstrekte gram weet je uit welke partij die komt.",
  "web.detras.caja": "Kassa",
  "web.detras.caja.texto":
    "De kassadienst begint met een startbedrag, verzamelt verstrekkingen, bar en contante uitgaven, en bij het afsluiten tel je de lade: het programma zegt wat erin zou moeten zitten en wat het kasverschil is. Uitgaven via automatische incasso raken de kassa niet.",
  "web.detras.cartera": "Tegoed",
  "web.detras.cartera.texto":
    "Prepaidtegoed van het lid: opwaarderingen, bestedingen, terugbetalingen. Aan de balie reken je met één tik van het tegoed af, en als het niet genoeg is, zegt het programma dat.",
  "web.detras.barra": "Bar",
  "web.detras.barra.texto":
    "Koffie, frisdrank en snacks met een eigen kaart en snel afrekenen. Ze gaan naar dezelfde kassa, maar de kasopmaak houdt bar en verstrekking uit elkaar.",
  "web.detras.portal": "Ledenportaal",
  "web.detras.portal.texto":
    "Op zijn telefoon, als een app: de ledenpas met QR om zich aan de balie te identificeren, zijn verbruik tegenover zijn limieten, zijn tegoed, de catalogus met de bijdrage per gram, het nieuws van de club en reserveringen om op te halen. In {idiomas}.",
  "web.detras.cuotas": "Contributie en verlengingen",
  "web.detras.cuotas.texto":
    "Innen, verloopdatums en een herinnering per e-mail voordat een lidmaatschap verloopt. Donaties staan apart, zodat ze bij niemand de datum verschuiven.",
  "web.detras.gastos": "Uitgaven en inkopen",
  "web.detras.gastos.texto":
    "Wat je de leverancier nog schuldig bent en wat er betaald is, met categorie, op één scherm. Export voor de boekhouder.",
  "web.detras.acceso": "Toegang en capaciteit",
  "web.detras.acceso.texto":
    "Wie er nu binnen is en hoeveel mensen er vandaag zijn geweest. Stel je een maximale bezetting in, dan waarschuwt het als het vol is: het sluit de deur niet.",
  "web.detras.informes": "Rapporten",
  "web.detras.informes.texto":
    "Waar het geld per dag of per maand vandaan komt, met verstrekking, bar en contributie apart. Ranglijst van producten en van leden.",
  "web.detras.carta": "Kaart voor het scherm in de club",
  "web.detras.carta.texto":
    "Een pagina op volledig scherm met wat er vandaag is en de bijdrage, die tegen een netwerkstoring kan.",

  "web.precio": "Prijs",
  "web.precio.texto":
    "Het gaat per omvang, en de <b>actieve</b> leden tellen: uitgeschreven leden van vorige jaren maken je prijs niet hoger. Alle functies en het hele team zitten in elke staffel.",
  "web.precio.sociosActivos": "Actieve leden",
  "web.precio.alMes": "Per maand",
  "web.precio.hablamos": "In overleg",
  "web.precio.consultanos": "Neem contact op",
  "web.tramo.hasta": "Tot {hasta} leden",
  "web.tramo.entre": "Van {desde} tot {hasta} leden",
  "web.tramo.mas": "Meer dan {desde} leden",
  "web.precio.prueba": "{dias} op proef om het met je eigen gegevens te zien.",
  "web.precio.condiciones":
    "Geen minimale looptijd: stop je ermee, dan neem je je gegevens mee, en je kunt de hele club wanneer je wilt in één bestand downloaden, ook op de dag dat je weggaat. Groeit de club en verandert de staffel, dan zeggen we het van tevoren; er wordt nooit iets geblokkeerd. Updates zitten erbij.",

  "web.datos": "Over de gegevens",
  "web.datos.texto":
    "Een club werkt met identiteitsbewijzen, foto's en het verbruik van zijn leden: persoonsgegevens van echte mensen. Elke club staat los van de andere, wachtwoorden worden versleuteld bewaard en alles wat er gebeurt komt in een logboek met wie en wanneer. Van elke club wordt elke nacht een back-up gemaakt, en de club kan die zelf downloaden. De tablet aan de balie vergrendelt zichzelf als niemand hem aanraakt.",
  "web.datos.nota":
    "Het programma geeft je de middelen; de verwerkersovereenkomst met je leden en het bewaarbeleid bepaal je zelf, net als bij elke andere leverancier.",
  "web.empezar": "Hoe je begint",
  "web.empezar.nosEscribes": "Je schrijft ons",
  "web.empezar.conCodigo":
    "en wij antwoorden met een code om je in te schrijven. Ze gaan expres één voor één: elke club begint met iemand aan de andere kant.",
  "web.empezar.creasClub": "Je maakt je club aan",
  "web.empezar.sinCodigo": "met de naam, de gegevens van de vereniging en je eigenaarsaccount. Eén minuut.",
  "web.empezar.despues":
    "Daarna zet je je lidmaatschapsvormen, de contributie, de limieten en de catalogus klaar —wat je niet invult heeft een redelijke standaardwaarde—, en haal je je leden binnen met «CSV importeren», dat het register van je vorige programma leest. Dezelfde dag heb je al een balie.",
  "web.pie": "asocis · Beheer van cannabisverenigingen",
  "web.pie.avisoLegal": "Juridische kennisgeving",
  "web.pie.privacidad": "Privacy",

  "web.demoEnCastellano":
    "Deze voorbeeldbalie staat alleen in het Spaans; het echte programma en het ledenportaal zijn er in {idiomas}.",
  "prueba.titulo": "Proef aanvragen",
  "prueba.intro":
    "Nieuwe clubs gaan één voor één: we antwoorden met een code en daarmee zet je je club in een minuut op. Vertel je ons hoeveel leden jullie hebben, dan zeggen we meteen wat jullie gaan betalen.",
  "prueba.nombreClub": "Naam van de vereniging",
  "prueba.ciudad": "Plaats",
  "prueba.socios": "Leden, ongeveer",
  "prueba.sociosAyuda": "Optioneel. Dat bepaalt de prijs.",
  "prueba.tuNombre": "Je naam",
  "prueba.tuEmail": "Je e-mail",
  "prueba.tuEmailAyuda": "Daar sturen we de code naartoe.",
  "prueba.telefono": "Telefoon",
  "prueba.telefonoAyuda": "Optioneel, voor als bellen makkelijker is.",
  "prueba.mensaje": "Nog iets wat we moeten weten?",
  "prueba.mensajeAyuda": "Optioneel. Hoe jullie het nu doen, wat jullie missen, wanneer jullie willen beginnen.",
  "prueba.privacidad1": "Ik heb het",
  "prueba.privacidad2": "privacybeleid",
  "prueba.privacidad3": "gelezen en ga ermee akkoord dat jullie deze gegevens gebruiken om mij te antwoorden.",
  "prueba.enviar": "Proefperiode aanvragen",
  "prueba.fallo": "De aanvraag kon niet worden verstuurd",
  "prueba.recibido": "Ontvangen.",
  "prueba.recibidoTexto1": "We mailen je op",
  "prueba.recibidoTexto2": "met de code voor de inschrijving van",
  "prueba.recibidoTexto3": ", meestal binnen één werkdag. Zie je hem niet, kijk dan in je spamfolder.",
  "prueba.volverWeb": "Terug naar de website",

  "g.cargando": "Laden...",
  "g.cancelar": "Annuleren",
  "g.cerrar": "Sluiten",
  "g.guardar": "Opslaan",
  "g.anterior": "Vorige",
  "g.siguiente": "Volgende",
  "g.pagina": "Pagina {pagina} van {paginas}",
  "g.estado.ACTIVO": "Actief",
  "g.estado.PENDIENTE": "In afwachting",
  "g.estado.CADUCADO": "Verlopen",
  "g.estado.SUSPENDIDO": "Geschorst",
  "g.estado.BAJA": "Uitgeschreven",

  "m.titulo": "Balie",
  "m.descripcion": "Verstrekking aan een lid registreren",
  "m.dudaDeGuardado1": "Kijk in",
  "m.dudaDeGuardado2": "of de verstrekking geregistreerd is. Zo ja, doe hem niet opnieuw.",
  "m.dispensaciones": "Verstrekkingen",
  "m.reservas": "Op te halen reserveringen",
  "m.socio": "Lid",
  "m.pedido": "Bestelling",
  "m.total": "Totaal",
  "m.reservaNumero": "Reservering {numero}",
  "m.faltaGenero": "Voorraad ontbreekt",
  "m.cancelarReserva": "Annuleren",
  "m.can.titulo": "Reservering #{numero} annuleren",
  "m.can.quePasa":
    "Het lid ziet dat de reservering geannuleerd is, met de reden die je opschrijft, en kan weer reserveren. Als het portaal op de telefoon staat, krijgt het lid ook een melding.",
  "m.can.motivo": "Reden die het lid leest",
  "m.can.confirmar": "Reservering annuleren",
  "m.can.fallo": "De reservering kon niet worden geannuleerd",
  "m.can.hecho": "Reservering geannuleerd",
  "m.atender": "Afhandelen",
  "m.aQuien": "Aan wie wordt verstrekt?",
  "m.comoBuscar": "Typ minstens twee letters van de naam, het lidnummer of het documentnummer.",
  "m.todo": "Alles",
  "m.sinProductos": "Er zijn geen producten beschikbaar in deze categorie.",
  "m.reservado": "{cantidad} gereserveerd",
  "m.sinStock": "Geen voorraad",
  "m.cambiar": "Wijzigen",
  "m.hoy": "Vandaag",
  "m.esteMes": "Deze maand",
  "m.cartera": "Tegoed",
  "m.ingresar": "+ Opwaarderen",
  "m.ingresarTitulo": "Tegoed van het lid opwaarderen",
  "m.cuotaVencioHace": "Het lidmaatschap is {dias} geleden verlopen.",
  "m.cuotaVenceHoy": "Het lidmaatschap verloopt vandaag.",
  "m.cuotaVenceEn": "Het lidmaatschap verloopt over {dias}.",
  "m.cobrarAhora": "Nu innen",
  "m.entrega": "Verstrekking",
  "m.tocaProducto": "Tik op een product om het toe te voegen.",
  "m.quitar": "Verwijderen",
  "m.ahorro": "Voordeel {importe}",
  "m.descuentoAMano": "Handmatige korting −{importe}",
  "m.descuento": "Korting",
  "m.quitarDescuento": "Korting verwijderen",
  "m.hacerDescuento": "Korting geven",
  "m.superaLimiteCorto": "Overschrijdt de beschikbare limiet ({disponible}).",
  "m.registrando": "Bezig met registreren...",
  "m.registrar": "Verstrekking registreren · {total}",
  "m.irACobrar": "Betaling innen",
  "m.falloRegistrar": "De verstrekking kon niet worden geregistreerd",
  "m.superaLimite":
    "Overschrijdt de beschikbare limiet: het lid mag {disponible} afhalen en er wordt {pedido} gevraagd",
  "m.soloPropietario": "Alleen een beheerder of hoger mag toestemming geven om over de limiet te gaan",

  "m.sinFichar.titulo": "Niet ingecheckt",
  "m.sinFichar.texto": "staat niet binnen geregistreerd. Je kunt het lid nu inchecken en doorgaan met de verstrekking.",
  "m.sinFichar.nota":
    "Als je niet incheckt, wordt de verstrekking gewoon geregistreerd, maar telt het lid niet mee voor de bezetting en staat het niet in het bezoekersregister van vandaag.",
  "m.sinFichar.seguir": "Doorgaan zonder inchecken",
  "m.sinFichar.fichar": "Inchecken en doorgaan",
  "m.sinFichar.fichando": "Bezig met inchecken...",
  "m.sinFichar.fallo": "Inchecken is niet gelukt",
  "m.limite.titulo": "Limiet wordt overschreden",
  "m.limite.autorizar": "Toestaan en registreren",
  "m.limite.nota":
    "Alleen een beheerder of hoger kan dit toestaan. De toestemming komt met jouw naam in het auditlogboek te staan.",
  "m.venta.enCola": "Verstrekking opgeslagen op deze tablet",
  "m.venta.registrada": "Verstrekking #{numero} geregistreerd",
  "m.venta.quedan": "Er staat nog {importe} op het tegoed",

  "s.titulo": "Leden",
  "s.enElRegistro": "{socios} in het ledenregister",
  "s.exportar": "CSV exporteren",
  "s.libro": "Ledenregister",
  "s.importar": "CSV importeren",
  "s.carnets": "Ledenpassen",
  "s.nuevo": "+ Nieuw lid",
  "s.falloExportar": "Exporteren is niet gelukt",
  "s.buscar": "Zoeken op naam, nummer of document...",
  "s.todosLosEstados": "Alle statussen",
  "s.cualquierTipo": "Alle lidmaatschapsvormen",
  "s.hanVenidoDesde": "Langs geweest sinds",
  "s.sinCoincidencias": "Geen leden gevonden voor deze zoekopdracht.",
  "s.sinSocios": "Er zijn nog geen leden.",
  "s.darDeAlta": "Schrijf het eerste lid in",
  "s.oImportar": "importeer de leden die jullie al hebben",
  "s.numero": "Nr.",
  "s.socio": "Lid",
  "s.documento": "Document",
  "s.estado": "Status",
  "s.cuotaHasta": "Lid tot",
  "s.ultimaVisita": "Laatste bezoek",
  "s.aportado": "Bijgedragen",
  "s.cartera": "Tegoed",
  "s.anios": "{anios} jaar",
  "s.sinTelefono": "geen telefoon",
  "s.queda": "nog {dias}",
  "s.quedan": "nog {dias}",
  "s.nunca": "Nooit",
  "s.hoy": "vandaag",
  "s.ayer": "gisteren",
  "s.haceDias": "{dias} dagen geleden",
  "s.haceUnMes": "een maand geleden",
  "s.haceMeses": "{meses} maanden geleden",
  "s.haceUnAnio": "een jaar geleden",
  "s.haceAnios": "{anios} jaar geleden",

  "b.marcador": "Lid zoeken op naam, nummer of DNI...",
  "b.escanear": "Ledenpas van het lid scannen",
  "b.sinCoincidencias": "Geen lid gevonden voor «{texto}»",
  "b.codigoDesconocido": "Die code hoort niet bij een lid van deze club.",
  "b.falloCodigo": "De code kon niet worden gecontroleerd. Probeer het opnieuw.",
  "b.escanearBoton": "Scannen",
  "b.qr.sinCamara": "Deze browser geeft geen toegang tot de camera. Typ het lidnummer met de hand.",
  "b.qr.sinPermiso":
    "Je hebt geen toestemming gegeven om de camera te gebruiken. Dat kan via het slotje in de adresbalk.",
  "b.qr.sinDispositivo": "Er is geen camera gevonden op dit apparaat.",
  "b.qr.falloCamara": "De camera kon niet worden geopend. Typ het lidnummer met de hand.",
  "b.qr.apunta": "Richt de camera op de code van het lid. Zodra die gelezen is, wordt het lid vanzelf herkend.",
  "m.productos": "{n} producten",
  "m.unProducto": "1 product",

  "c.titulo": "Kassa",
  "c.descripcion": "Kassadiensten en kasopmaak van het contante geld",
  "c.entradaSalida": "In / uit",
  "c.cerrarCaja": "Kassa afsluiten",
  "c.abrirCaja": "Kassa openen",
  "c.sinCaja":
    "Je hebt geen kassa open. Zolang die dicht blijft, komen contante betalingen in geen enkele kasopmaak terecht.",
  "c.otraAbierta": "Er is een andere kassa open in de club, en wat jij int komt daar niet in.",
  "c.otrasAbiertas": "Er zijn nog {n} andere kassa's open in de club, en wat jij int komt daar niet in.",
  "c.fondoInicial": "Startbedrag",
  "c.abiertaALas": "Geopend om {hora}",
  "c.dispensaciones": "Verstrekkingen",
  "c.barra": "Bar",
  "c.cuotasYRecargas": "Contributies en opwaarderingen",
  "c.gastos": "Uitgaven",
  "c.deberiaHaber": "Zou er moeten zijn",
  "c.formula": "Startbedrag + in − uit",
  "c.movimientos": "Mutaties van deze kassadienst",
  "c.sinMovimientos": "Er zijn nog geen mutaties in deze kassadienst.",
  "c.hora": "Tijd",
  "c.tipo": "Type",
  "c.concepto": "Omschrijving",
  "c.usuario": "Gebruiker",
  "c.importe": "Bedrag",
  "c.historial": "Eerdere kassadiensten",

  "c.fa.titulo": "Contant geld buiten elke telling",
  "c.fa.explicacion":
    "{cuantos} keer is er contant afgerekend zonder open kassa, {importe} in totaal: dat geld ligt in de lade en telt bij geen enkele dienst mee. Dat gebeurt als je afrekent met de kassa dicht, en bij verstrekkingen zonder verbinding die pas worden verstuurd als de dienst van wie ze deed al voorbij is.",
  "c.fa.explicacionUno":
    "Eén contante betaling van {importe} is aangenomen zonder open kassa: dat geld ligt in de lade en telt bij geen enkele dienst mee. Dat gebeurt als je afrekent met de kassa dicht, en bij verstrekkingen zonder verbinding die pas worden verstuurd als de dienst van wie ze deed al voorbij is.",
  "c.fa.cuando": "Wanneer",
  "c.fa.que": "Wat",
  "c.fa.importe": "Bedrag",
  "c.fa.hayMas": "Alleen de 100 meest recente worden getoond.",
  "c.fa.tipo.DISPENSACION": "Verstrekking",
  "c.fa.tipo.BARRA": "Bar",
  "c.fa.tipo.CUOTA": "Contributie",
  "c.fa.tipo.DONACION": "Donatie",
  "c.fa.tipo.RECARGA": "Opwaardering",
  "c.fa.tipo.GASTO": "Uitgave",
  "c.sinTurnos": "Er is nog geen kassadienst afgesloten.",
  "c.apertura": "Opening",
  "c.cierre": "Afsluiting",
  "c.responsable": "Verantwoordelijke",
  "c.teorico": "Verwacht",
  "c.contado": "Geteld",
  "c.diferencia": "Verschil",
  "c.abierta": "Open",
  "c.cuadra": "Klopt",
  "c.abrir.titulo": "Kassa openen",
  "c.abrir.fondo": "Startbedrag in de kassa (credits)",
  "c.abrir.fondoAyuda": "Het geld waarmee de kassadienst begint.",
  "c.abrir.notas": "Notities",
  "c.abrir.notasEjemplo": "Middagdienst...",
  "c.abrir.boton": "Openen",
  "c.abrir.fallo": "De kassa kon niet worden geopend",
  "c.cerrar.titulo": "Kassa afsluiten",
  "c.cerrar.segunSistema": "Volgens het systeem zou er moeten zijn",
  "c.cerrar.contado": "Geteld geld in de lade (credits)",
  "c.cerrar.descuadre": "Kasverschil van",
  "c.cerrar.sobra": "(er is geld te veel).",
  "c.cerrar.falta": "(er is geld te weinig).",
  "c.cerrar.cuadra": "De kassa klopt precies.",
  "c.cerrar.observaciones": "Opmerkingen bij de afsluiting",
  "c.cerrar.boton": "Kassadienst afsluiten",
  "c.cerrar.fallo": "De kassa kon niet worden afgesloten",
  "c.mov.titulo": "Kassamutatie",
  "c.mov.tipo": "Type",
  "c.mov.salida": "Contant geld opnemen",
  "c.mov.entrada": "Contant geld inleggen",
  "c.mov.nota1": "Voor een factuur of een inkoop gebruik je",
  "c.mov.gastos": "Uitgaven",
  "c.mov.nota2": ": dan gaat het geld niet alleen uit de kassa, maar wordt het ook gecategoriseerd.",
  "c.mov.importe": "Bedrag (credits)",
  "c.mov.concepto": "Omschrijving",
  "c.mov.conceptoEjemplo": "Inkoop van materiaal...",
  "c.mov.boton": "Registreren",
  "c.mov.fallo": "De mutatie kon niet worden geregistreerd",
  "movimiento.ENTRADA": "Inleg",
  "movimiento.SALIDA": "Opname",
  "movimiento.DISPENSACION": "Verstrekking",
  "movimiento.MERMA": "Derving",
  "movimiento.GASTO": "Uitgave",

  "i.titulo": "Voorraadbeheer",
  "i.descripcion": "Ontvangsten, derving en voorraadtellingen",
  "i.almacen": "Magazijn",
  "i.movimientos": "Mutaties",
  "i.exportar": "CSV exporteren",
  "i.falloExportar": "Exporteren is niet gelukt",
  "i.enElMostrador": "Op de balie",
  "i.valor": "Waarde van de voorraad",
  "i.valorPie": "Op basis van de catalogusbijdrage",
  "i.coste": "Kostprijs van wat er ligt",
  "i.costePie": "Wat ervoor betaald is",
  "i.avisos": "Waarschuwingen",
  "i.avisosPie": "{bajos} onder minimum · {caducan} bijna over datum",
  "i.porCaducar": "Partijen die bijna over datum zijn:",
  "i.buscar": "Product of categorie zoeken...",
  "i.nProductos": "{n} producten",
  "i.unProducto": "1 product",
  "i.sinProductos": "Er zijn geen producten. Maak ze eerst aan in de catalogus.",
  "i.producto": "Product",
  "i.categoria": "Categorie",
  "i.unidad": "Eenheid",
  "i.enVenta": "Op de balie",
  "i.guardado": "In het magazijn",
  "i.total": "Totaal",
  "i.minimo": "Minimum",
  "i.lotes": "Partijen",
  "i.caduca": "Houdbaar tot",
  "i.valorColumna": "Waarde",
  "i.costeColumna": "Kostprijs",
  "i.bajoMinimo": "onder minimum",
  "i.inactivo": "Inactief",
  "i.entrada": "Ontvangst",
  "i.merma": "Derving",
  "i.ajuste": "Correctie",
  "i.ultimos": "Laatste mutaties",
  "i.sinRegistros": "Geen mutaties geregistreerd.",
  "i.fecha": "Datum",
  "i.tipo": "Type",
  "i.cantidad": "Hoeveelheid",
  "i.op.entrada": "Ontvangst van {producto}",
  "i.op.merma": "Derving van {producto}",
  "i.op.ajuste": "Correctie van {producto}",
  "i.op.stockActual": "Huidige voorraad:",
  "i.op.cantidad": "Hoeveelheid",
  "i.op.stockContado": "Werkelijk getelde voorraad",
  "i.op.ajusteAyuda": "Het verschil met de voorraad in het systeem wordt vastgelegd.",
  "i.op.codigoLote": "Partijnummer",
  "i.op.codigoAyuda": "Laat je het leeg, dan wordt het vanzelf aangemaakt.",
  "i.op.costeTotal": "Totale kostprijs (credits)",
  "i.op.proveedor": "Herkomst / leverancier",
  "i.op.caducidad": "Houdbaar tot",
  "i.op.motivo": "Reden",
  "i.op.motivoAyuda": "Blijft in de geschiedenis staan.",
  "i.op.registrar": "Registreren",
  "i.op.fallo": "De handeling kon niet worden geregistreerd",
  "i.gd.titulo": "Magazijn · {producto}",
  "i.gd.enVenta": "Op de balie:",
  "i.gd.guardado": "In het magazijn:",
  "i.gd.queSeHace": "Wat je doet",
  "i.gd.aVenta": "Van het magazijn naar de balie",
  "i.gd.aGuardado": "Van de balie naar het magazijn",
  "i.gd.comoMucho": "Hoogstens {cantidad}.",
  "i.gd.motivoAyuda": "Optioneel. Blijft in de geschiedenis van de mutaties staan.",
  "i.gd.moviendo": "Verplaatsen...",
  "i.gd.sacar": "Naar de balie halen",
  "i.gd.fallo": "Verplaatsen is mislukt",
  "g.guardando": "Opslaan...",
  "i.guardadosPie": "{cantidad} in het magazijn",

  "ba.titulo": "Bar",
  "ba.descripcion": "Koffie, frisdrank en alles wat geen verstrekking is",
  "ba.carta": "Barkaart",
  "ba.vacia": "De barkaart is leeg.",
  "ba.vaciaAdmin": " Voeg met «Barkaart» toe wat jullie verkopen.",
  "ba.vaciaSocio": " Vraag een beheerder om hem klaar te zetten.",
  "ba.sinExistencias": "Geen voorraad",
  "ba.agotado": "Op",
  "ba.quedan": "Nog {n}",
  "ba.cobro": "Afrekenen",
  "ba.tocaProducto": "Tik op een product om te beginnen.",
  "ba.cadaUno": "{importe} p/st",
  "ba.vaciar": "Leegmaken",
  "ba.cobrando": "Afrekenen...",
  "ba.cobrar": "Afrekenen {total}",
  "ba.faltaSocio": "Om van het tegoed af te rekenen moet je een lid kiezen.",
  "ba.hoy": "Bar van vandaag",
  "ba.unCobro": "1 afrekening",
  "ba.cobros": "{n} afrekeningen",
  "ba.ultimos": "Laatste afrekeningen",
  "ba.sinCobros": "Vandaag is er nog niets afgerekend aan de bar.",
  "ba.anulada": "Geannuleerd",
  "ba.falloCobrar": "Afrekenen is mislukt",
  "ba.cobrado": "{importe} afgerekend · barbon {numero}",
  "ba.c.nombre": "Naam",
  "ba.c.nombreEjemplo": "Koffie verkeerd",
  "ba.c.grupo": "Groep",
  "ba.c.grupoAyuda": "Om ze op het scherm te groeperen.",
  "ba.c.grupoPorDefecto": "Dranken",
  "ba.c.precio": "Prijs (credits)",
  "ba.c.existencias": "Voorraad",
  "ba.c.existenciasAyuda": "Alleen als je de voorraad wilt bijhouden.",
  "ba.c.llevarCuenta": "Voorraad bijhouden",
  "ba.c.llevarCuentaNota": "Koffie uit de machine hoef je niet bij te houden, een doos blikjes wel.",
  "ba.c.anadir": "Aan de kaart toevoegen",
  "ba.c.producto": "Product",
  "ba.c.precioColumna": "Prijs",
  "ba.c.quedan": "nog {n}",
  "ba.c.quitar": "Verwijderen",
  "ba.c.reponer": "Aanvullen",
  "ba.c.fallo": "Opslaan is mislukt",

  "d.titulo": "Verstrekkingen en bar",
  "d.descripcion": "Alles wat eruit is gegaan, bon voor bon",
  "d.a": "t/m",
  "d.exportar": "CSV exporteren",
  "d.falloExportar": "Exporteren is mislukt",
  "d.dispensario": "Balie",
  "d.barra": "Bar",
  "d.buscar": "Zoek lid, product of bonnummer",
  "d.atendioCualquiera": "Alle medewerkers",
  "d.baja": " (uitgeschreven)",
  "d.todosLosPuestos": "Alle werkplekken",
  "d.todos": "Alle",
  "d.soloValidos": "Alleen geldige",
  "d.soloAnulados": "Alleen geannuleerde",
  "d.quitarFiltros": "Filters wissen",
  "d.entregas": "Verstrekkingen",
  "d.cobros": "Afrekeningen",
  "d.unAnulado": "1 geannuleerd",
  "d.anulados": "{n} geannuleerd",
  "d.cantidad": "Hoeveelheid",
  "d.aportaciones": "Bijdragen",
  "d.deDescuento": "{importe} korting",
  "d.aMano": "{importe} handmatig",
  "d.sinCoincidencias": "Geen enkele bon komt overeen met wat je zoekt.",
  "d.sinDispensaciones": "Er zijn geen verstrekkingen in deze periode.",
  "d.sinCobros": "Er is in deze periode niets afgerekend aan de bar.",
  "d.numero": "Nr.",
  "d.fecha": "Datum",
  "d.socio": "Lid",
  "d.productos": "Producten",
  "d.articulos": "Artikelen",
  "d.descuento": "Korting",
  "d.importe": "Bedrag",
  "d.atendio": "Geholpen door",
  "d.laSubio": "Verstuurd door {nombre}",
  "d.sinSocio": "Geen lid",
  "d.anulada": "Geannuleerd",
  "d.sinConexion": "Offline",
  "d.sinConexionAyuda": "Offline gemaakt en verstuurd toen de verbinding terugkwam",
  "d.descuentoAMano": "handmatig {importe}",
  "d.ticket": "Bon",
  "d.anular": "Annuleren",
  "d.tope":
    "Je ziet de recentste afrekeningen van de periode, tot maximaal {tope}. Verklein de periode om de rest te zien.",
  "d.ticketNumero": "Bon #{numero}",
  "d.imprimir": "Afdrukken",
  "d.an.tituloDispensacion": "Verstrekking #{numero} annuleren",
  "d.an.tituloVenta": "Afrekening #{numero} annuleren",
  "d.an.dispensario": "{cantidad} gaat terug naar de voorraad.",
  "d.an.dispensarioCartera":
    "{cantidad} gaat terug naar de voorraad en {importe} wordt teruggestort op het tegoed van het lid.",
  "d.an.dispensarioCaja": "{cantidad} gaat terug naar de voorraad en {importe} wordt als uitname in de kassa geboekt.",
  "d.an.barra": "De stuks gaan terug naar de voorraad van de bar.",
  "d.an.barraCartera":
    "De stuks gaan terug naar de voorraad van de bar en {importe} wordt teruggestort op het tegoed van het lid.",
  "d.an.barraCaja":
    "De stuks gaan terug naar de voorraad van de bar en {importe} wordt als uitname in de kassa geboekt.",
  "d.an.motivo": "Reden van de annulering",
  "d.an.anular": "Ja, annuleren",
  "d.an.fallo": "Annuleren is mislukt",

  "tk.preparando": "Bon voorbereiden...",
  "tk.ticket": "Bon #{numero}",
  "tk.socio": "Lid #{numero}",
  "tk.atiende": "Geholpen door",
  "tk.anulada": "*** GEANNULEERD ***",
  "tk.unidades": "{cantidad} st x {precio}",
  "tk.gramos": "{cantidad} g x {precio}/g",
  "tk.catalogo": "{texto} · catalogus {importe}",
  "tk.total": "TOTAAL",
  "tk.descuentoAplicado": "Korting toegepast",
  "tk.descuento": "Korting",
  "tk.descuentoCon": "Korting {texto}",
  "tk.totalDispensado": "Totaal verstrekt",
  "tk.formaDePago": "Betaalwijze",
  "tk.saldoRestante": "Resterend saldo",
  "tk.documentoInterno": "Intern document van de vereniging. Dit is geen factuur.",

  "nav.gestionDe": "Beheer van de vereniging",
  "nav.inicio": "Overzicht",
  "nav.mostrador": "Balie",
  "nav.grupoAsociacion": "Vereniging",
  "nav.donaciones": "Donaties",
  "nav.socios": "Leden",
  "nav.caja": "Kassa",
  "nav.gastos": "Uitgaven en inkopen",
  "nav.inventario": "Voorraadbeheer",
  "nav.recuentos": "Tellingen",
  "nav.barra": "Bar",
  "nav.dispensaciones": "Verstrekkingen",
  "nav.descuentos": "Kortingen",
  "nav.grupoAjustes": "Instellingen",
  "nav.informes": "Rapporten",
  "nav.ajustes": "Instellingen",
  "nav.dias": "Dagen",
  "nav.contrato": "Contract",
  "nav.accesos": "Toegang",
  "nav.renovaciones": "Verlengingen",
  "nav.cuotas": "Contributies",
  "nav.comunidad": "Community",
  "nav.catalogo": "Catalogus",
  "nav.cartas": "Kaarten",
  "nav.contrasena": "Wachtwoord",
  "rol.PROPIETARIO": "Eigenaar",
  "rol.TRABAJADOR": "Medewerker",
  "nav.pw.titulo": "Mijn wachtwoord wijzigen",
  "nav.pw.hecho": "Wachtwoord gewijzigd. Gebruik het de volgende keer dat je inlogt.",
  "nav.pw.actual": "Huidig wachtwoord",
  "nav.pw.nueva": "Nieuw wachtwoord",
  "nav.pw.minimo": "Minimaal 8 tekens.",
  "nav.pw.repetir": "Herhaal het nieuwe",
  "nav.pw.noCoinciden": "Komen niet overeen.",
  "nav.pw.cambiar": "Wijzigen",
  "nav.pw.fallo": "Het wachtwoord kon niet worden gewijzigd",

  "p.buenosDias": "Goedemorgen",
  "p.buenasTardes": "Goedemiddag",
  "p.buenasNoches": "Goedenavond",
  "p.saludo": "{saludo}, {nombre}",
  "p.descripcion": "Overzicht van de activiteit van de club",
  "p.nuevaDispensacion": "Nieuwe verstrekking",
  "p.sinCaja": "Er is geen kassa open. Contante afrekeningen komen niet in de kasopmaak terecht.",
  "p.abrirCaja": "Kassa openen",
  "p.unaSolicitud": "Er wacht 1 inschrijvingsaanvraag op antwoord.",
  "p.solicitudes": "Er wachten {n} inschrijvingsaanvragen op antwoord.",
  "p.verSolicitudes": "Aanvragen bekijken",
  "p.unaCuotaVencida": "1 lid met een verlopen lidmaatschap.",
  "p.cuotasVencidas": "{n} leden met een verlopen lidmaatschap.",
  "p.unaPorVencer": "1 lidmaatschap verloopt in de komende 30 dagen.",
  "p.porVencer": "{n} lidmaatschappen verlopen in de komende 30 dagen.",
  "p.verRenovaciones": "Verlengingen bekijken",
  "p.pocoStockDe": "Er is weinig voorraad van {producto}.",
  "p.bajoMinimo": "Er zijn {n} producten onder de minimumvoorraad.",
  "p.verInventario": "Voorraadbeheer bekijken",
  "p.dispensadoHoy": "Vandaag verstrekt",
  "p.unaEntrega": "1 verstrekking",
  "p.entregas": "{n} verstrekkingen",
  "p.unSocio": "1 lid",
  "p.socios": "{n} leden",
  "p.entregasASocios": "{entregas} aan {socios}",
  "p.aportacionesHoy": "Bijdragen vandaag",
  "p.cajaAbierta": "Kassa open",
  "p.sinCajaAbierta": "Geen kassa open",
  "p.barraHoy": "Bar vandaag",
  "p.sociosActivos": "Actieve leden",
  "p.enTotal": "{n} in totaal",
  "p.esteMes": "Deze maand",
  "p.enEntregas": "{importe} in {entregas}",
  "p.masDispensado": "Meest verstrekt vandaag",
  "p.nadaHoy": "Vandaag is er nog niets uitgegaan.",
  "p.producto": "Product",
  "p.entregasColumna": "Verstrekkingen",
  "p.cantidad": "Hoeveelheid",
  "p.importe": "Bedrag",
  "p.masBarra": "Meest verkocht aan de bar vandaag",
  "p.nadaBarra": "Vandaag niets aan de bar.",
  "p.cobrosColumna": "Afrekeningen",
  "p.unidades": "Stuks",
  "p.ultimas": "Laatste verstrekkingen",
  "p.sinDispensaciones": "Er zijn nog geen verstrekkingen geregistreerd.",
  "p.socio": "Lid",
  "p.fecha": "Datum",
  "p.anulada": "Geannuleerd",
  "p.primerosPasos": "Eerste stappen",
  "p.recienCreado": "De club is net aangemaakt. Dit kun je het beste klaarzetten voordat je de balie opent:",
  "p.paso.ajustes": "Controleer de instellingen",
  "p.paso.ajustesResto": ": daglimiet en maandlimiet per lid, jaarcontributie en gegevens van de vereniging.",
  "p.paso.catalogo": "Maak de soorten aan",
  "p.paso.catalogoResto": " met hun bijdrage per gram. De basiscategorieën staan er al.",
  "p.paso.stock": "Voer de beginvoorraad in",
  "p.paso.stockResto": " met één ontvangst per partij van elke soort.",
  "p.paso.socio": "Schrijf het eerste lid in",
  "p.paso.socioResto": " en incasseer de contributie.",
  "p.paso.caja": "Open de kassa",
  "p.paso.cajaResto": " bij het begin van de kassadienst, zodat het contante geld klopt.",
  "p.estadoSocios": "Status van de leden",
  "p.stockBajo": "Lage voorraad",

  "il.buscarSocio": "Lid zoeken",
  "il.nuevoSocio": "Nieuw lid",
  "il.dispensar": "Verstrekken",
  "il.barra": "Bar",
  "il.dentroAhora": "Nu binnen",
  "il.aforoCompleto": "Vol",
  "il.hanPasadoHoy": "Vandaag langs geweest",
  "il.solicitudes": "Inschrijvingsaanvragen",
  "il.esperando": "in behandeling",
  "il.anotarGasto": "Uitgave noteren",

  "pp.paraEmpezar": "Om te beginnen",
  "pp.enEsteOrden": "In deze volgorde gaat het het snelst. Dit verdwijnt vanzelf zodra jullie draaien.",
  "pp.hechosDe": "{hechos} van {total}",
  "pp.ir": "Openen",
  "pasos.datos.titulo": "Vul de gegevens van de club in",
  "pasos.datos.detalle": "Naam, CIF en adres. Die staan op de bonnen en in het ledenregister.",
  "pasos.productos.titulo": "Maak je catalogus",
  "pasos.productos.detalle": "De categorieën staan er al. Voeg toe wat jullie verstrekken, met de bijdrage erbij.",
  "pasos.stock.titulo": "Zet je voorraad erin",
  "pasos.stock.detalle":
    "Eén ontvangst per partij, met leverancier en kostprijs. Daar komt de traceerbaarheid vandaan.",
  "pasos.socios.titulo": "Schrijf de leden in",
  "pasos.socios.detalle": "Eén voor één, of door de CSV te importeren van het programma dat jullie eerst gebruikten.",
  "pasos.equipo.titulo": "Voeg je team toe",
  "pasos.equipo.detalle": "Iedereen met een eigen account en rol: zo laat het logboek zien wie wat heeft gedaan.",
  "pasos.caja.titulo": "Open de kassa van vandaag",
  "pasos.caja.detalle":
    "Met het beginbedrag. Bij het afsluiten vergelijkt de kasopmaak wat je telt met wat er zou moeten zijn.",

  "as.soloLectura": "Het programma staat op alleen-lezen.",
  "as.llevaSinRegularizar":
    "Het abonnement staat al {dias} open. Jullie kunnen alles inzien en de back-ups downloaden bij Instellingen, maar geen nieuwe mutaties vastleggen. Zodra de betaling binnen is, werkt alles meteen weer.",
  "as.vencioAyer": "Het abonnement is gisteren verlopen.",
  "as.vencioHace": "Het abonnement is {dias} geleden verlopen.",
  "as.siSigue": "Voorlopig verandert er niets. Blijft het openstaan, dan gaat het programma op alleen-lezen.",
  "as.venceHoy": "Het abonnement verloopt vandaag{fecha}.",
  "as.venceManana": "Het abonnement verloopt morgen{fecha}.",
  "as.venceEn": "Het abonnement verloopt over {dias}{fecha}.",
  "as.entreParentesis": " ({fecha})",
  "as.noHayQueHacer": "Hier hoef je niets te doen: de datum past zich vanzelf aan zodra de betaling binnen is.",

  "bl.explicacion":
    "Het scherm is vanzelf vergrendeld omdat het niet werd gebruikt. Typ je wachtwoord om verder te gaan waar je gebleven was.",
  "bl.tuContrasena": "Je wachtwoord",
  "bl.comprobando": "Controleren...",
  "bl.continuar": "Doorgaan",
  "bl.salirOtraCuenta": "Uitloggen en met een ander account inloggen",
  "bl.fallo": "Het wachtwoord kon niet worden gecontroleerd",

  "ec.sinConexion": "Geen verbinding met de server.",
  "ec.sinConexionDesde": "Geen verbinding met de server sinds {hora}.",
  "ec.conPaquete":
    "De balie werkt door met wat er op deze tablet staat: de verstrekkingen worden hier vastgelegd en vanzelf verstuurd zodra het netwerk terug is.",
  "ec.sinPaquete": "Deze tablet heeft de catalogus niet opgeslagen: tot het netwerk terug is kun je niet verstrekken.",
  "ec.unaPendiente": "1 verstrekking wacht op verzending.",
  "ec.pendientes": "{n} verstrekkingen wachten op verzending.",
  "ec.unaRechazada": "1 geweigerd door de server.",
  "ec.rechazadas": "{n} geweigerd door de server.",
  "ec.hayRechazada": "Er is 1 verstrekking die de server niet heeft geaccepteerd: bekijk hem.",
  "ec.hayRechazadas": "Er zijn {n} verstrekkingen die de server niet heeft geaccepteerd: bekijk ze.",
  "ec.verCola": "Wachtrij bekijken ({n})",
  "ec.enviando": "Versturen...",
  "ec.enviarAhora": "Nu versturen",
  "ec.titulo": "Verstrekkingen die op deze tablet staan",
  "ec.explicacion":
    "Ze zijn zonder verbinding gedaan en worden vanzelf verstuurd zodra het netwerk terug is, in deze volgorde. De server rekent ze af met de bedragen die daar gelden en noteert wat er overschreden is (limiet, voorraad, saldo) als afwijking bij de verstrekking.",
  "ec.nadaPorEnviar": "Er staat niets meer klaar om te versturen.",
  "ec.cuando": "Wanneer",
  "ec.socio": "Lid",
  "ec.que": "Wat",
  "ec.importe": "Bedrag",
  "ec.estado": "Status",
  "ec.rechazada": "Geweigerd: {motivo}",
  "ec.reintentar": "Opnieuw proberen",
  "ec.descartar": "Weggooien",
  "ec.confirmarDescartar": "Deze verstrekking weggooien? Hij wordt nergens vastgelegd.",
  "ec.pendienteDeEnviar": "Wacht op verzending",
  "ec.unIntento": " (1 poging)",
  "ec.intentos": " ({n} pogingen)",

  "gi.titulo": "Waar het geld vandaan komt",
  "gi.dias7": "7 dagen",
  "gi.dias30": "30 dagen",
  "gi.meses12": "12 maanden",
  "gi.dispensacion": "Verstrekking",
  "gi.barra": "Bar",
  "gi.cuotas": "Contributies",
  "gi.sinIngresos": "In deze periode zijn nog geen inkomsten vastgelegd.",

  "tb.dejarRecadoEquipo": "Een bericht voor het team achterlaten",
  "tb.titulo": "Prikbord",
  "tb.dejarRecado": "Een bericht achterlaten",
  "tb.ejemplo": "De nieuwe voorraad komt donderdagochtend aan...",
  "tb.fijarArriba": "Bovenaan vastzetten",
  "tb.poniendo": "Plaatsen...",
  "tb.poner": "Plaatsen",
  "tb.alguien": "Iemand",
  "tb.quitar": "Van het prikbord halen",

  "dc.titulo": "Contributie innen van {socio}",
  "dc.cobrando": "Innen...",
  "dc.cobrar": "Innen",
  "dc.importe": "Bedrag (credits)",
  "dc.periodo": "Periode",
  "dc.unAnio": "1 jaar",
  "dc.dosAnios": "2 jaar",
  "dc.tresAnios": "3 jaar",
  "dc.formaDePago": "Betaalwijze",
  "dc.carteraDelSocio": "Tegoed van het lid",
  "dc.nota":
    "Loopt de periode nog, dan sluit de nieuwe erop aan; is het lidmaatschap verlopen, dan gaat de nieuwe vandaag in.",
  "dc.fallo": "De contributie kon niet worden geïnd",

  "dr.titulo": "Storten op het tegoed van {socio}",
  "dr.ingresar": "{importe} storten",
  "dr.tieneAhora": "Heeft nu",
  "dr.leFaltan": "Er ontbreekt {importe} voor wat er wordt afgehaald.",
  "dr.importe": "Bedrag (credits)",
  "dr.formaDePago": "Betaalwijze",
  "dr.entraEnCaja": "Gaat in de kassa van deze kassadienst.",
  "dr.noTocaCaja": "Raakt de kassa niet.",
  "dr.seQuedaraCon": "Heeft straks",
  "dr.noEsIngreso": "Dit geld telt niet als inkomsten van de vereniging.",
  "dr.esDelSocio": "Het blijft van het lid tot het besteed wordt, en het lid kan het terugvragen.",
  "dr.confirmarTitulo": "Heb je het geld ontvangen?",
  "dr.todaviaNo": "Nog niet",
  "dr.ingresando": "Storten...",
  "dr.siIngresar": "Ja, storten",
  "dr.vasASumar": "Je zet {importe} bij op het tegoed van {socio}, dat daarmee op {total} komt.",
  "dr.confirmoEfectivo": "Ik bevestig dat ik {importe} contant heb ontvangen",
  "dr.confirmo": "Ik bevestig dat ik {importe} heb ontvangen",
  "dr.siTeEquivocas":
    "Als je je vergist kun je het rechtzetten vanaf de pagina van het lid, door het saldo terug te storten of te corrigeren, en van allebei blijft een spoor. Maar het is veel makkelijker om je nu niet te vergissen.",
  "dr.fallo": "Het storten is niet gelukt",

  "cc.entregado": "Ontvangen",
  "cc.aCobrar": "Te innen",
  "cc.cambio": "Wisselgeld",
  "cc.faltan": "Er ontbreekt {importe}",
  "cc.oEscribelo": "Of typ het",
  "cc.poner": "Invullen",
  "cc.empezarDeNuevo": "Opnieuw beginnen",

  "fp.firmado": "Getekend.",
  "fp.estaBien": "Klopt het? Bevestig het dan.",
  "fp.firmaAqui": "Teken hier met je vinger of de muis.",
  "fp.repetirTitulo": "Handtekening opnieuw zetten",
  "fp.repetir": "Opnieuw",
  "fp.confirmar": "Bevestigen",

  "ci.sinCamara": "Deze browser geeft geen toegang tot de camera. Upload de afbeelding vanaf de schijf.",
  "ci.sinPermiso":
    "Je hebt geen toestemming gegeven om de camera te gebruiken. Dat kan via het slotje in de adresbalk.",
  "ci.sinDispositivo": "Er is geen camera gevonden. Upload de afbeelding vanaf de schijf.",
  "ci.falloCamara": "De camera kon niet worden geopend. Upload de afbeelding vanaf de schijf.",
  "ci.obligatoria": "Verplicht",
  "ci.saltada": "Overgeslagen",
  "ci.hacerFoto": "Foto maken",
  "ci.repetir": "Opnieuw",
  "ci.camara": "Camera",
  "ci.subir": "Uploaden",
  "ci.quitar": "Verwijderen",

  "cs.titulo": "Ledencontract",
  "cs.firmoEl": "Heeft versie {numero} getekend op {fecha}.",
  "cs.firmo": "Heeft versie {numero} getekend.",
  "cs.sinFirmar":
    "Niet getekend. Hieronder staat die van vandaag (versie {numero}) met zijn gegevens, klaar om te printen.",
  "cs.verEImprimir": "Bekijken en printen",
  "cs.apuntando": "Vastleggen...",
  "cs.marcarFirmado": "Markeren als getekend",
  "cs.tambienPortal": "Het lid kan het ook zelf accepteren in het ledenportaal, dan wordt het vanzelf vastgelegd.",
  "cs.verContratoClub": "Het contract van de club bekijken",
  "cs.modalTitulo": "Contract · lid nr. {numero}",
  "cs.noFirmadoAun": "Nog niet getekend: dit is het document om mee te nemen naar de balie.",
  "cs.firmaDelSocio": "Handtekening van het lid",
  "cs.firmaYSello": "Handtekening en stempel van de vereniging",
  "cs.fallo": "De handtekening kon niet worden vastgelegd",

  "sn.titulo": "Nieuw lid",
  "sn.descripcion": "Pas aan het eind wordt het opgeslagen: tot dan kun je vrij vooruit en terug",
  "sn.paso.avalista": "Voordracht",
  "sn.paso.datos": "Gegevens",
  "sn.paso.documento": "Document",
  "sn.paso.contrato": "Contract",
  "sn.paso.cuota": "Contributie",
  "sn.paso.repaso": "Controle",
  "sn.falta.nombre": "Vul de voornaam in",
  "sn.falta.apellidos": "Vul de achternaam in",
  "sn.falta.nacimiento": "De geboortedatum ontbreekt",
  "sn.falta.documento": "Het documentnummer ontbreekt",
  "sn.falta.foto": "De foto van het lid ontbreekt",
  "sn.falta.frente": "De voorkant van het document ontbreekt",
  "sn.falta.reverso": "De achterkant van het document ontbreekt, of vink aan dat die er niet is",
  "sn.quienAvala": "Wie draagt dit lid voor?",
  "sn.avalistaNota":
    "In veel statuten moet een lid instaan voor wie erbij komt. Staat dat niet in die van jullie, sla het dan over.",
  "sn.quitar": "Verwijderen",
  "sn.quienEs": "Wie het is",
  "sn.nombre": "Voornaam",
  "sn.apellidos": "Achternaam",
  "sn.nacimiento": "Geboortedatum",
  "sn.consumo": "Verwacht verbruik (g/maand)",
  "sn.consumoAyuda": "Het lid geeft dit zelf op; het staat in het contract.",
  "sn.telefono": "Telefoon",
  "sn.email": "E-mail",
  "sn.dondeVive": "Waar het lid woont",
  "sn.direccion": "Adres",
  "sn.ciudad": "Plaats",
  "sn.cp": "Postcode",
  "sn.numeroSocio": "Lidnummer",
  "sn.numeroAyuda": "Leeg laten: dan het eerstvolgende nummer.",
  "sn.idioma": "Taal",
  "sn.idiomaAyuda": "Waarin het lid het portaal ziet en de contributiemails krijgt.",
  "sn.idiomaDelClub": "Die van de club",
  "sn.notas": "Interne notities",
  "sn.documento": "Identiteitsbewijs",
  "sn.tipo": "Type",
  "sn.pasaporte": "Paspoort",
  "sn.numero": "Nummer",
  "sn.fotoSocio": "Foto van het lid",
  "sn.fotoSocioAyuda": "Om het lid aan de balie te herkennen",
  "sn.docFrente": "Document, voorkant",
  "sn.docFrenteAyuda": "De kant met de foto",
  "sn.docReverso": "Document, achterkant",
  "sn.noLoTiene": "Heeft die niet",
  "sn.docReversoAyuda": "De achterkant",
  "sn.sinReverso": "Geen achterkant",
  "sn.fotosHacenFalta":
    "De foto's zijn nodig om iemand in te schrijven: alleen daarmee kun je later aantonen dat wie binnenkwam ook echt was wie hij zei te zijn. Heb je geen camera, dan kun je ze vanaf de schijf uploaden.",
  "sn.loQueFirma": "Wat het lid tekent",
  "sn.firma": "Handtekening",
  "sn.rgpd": "Heeft ook de toestemming voor gegevensverwerking (AVG) getekend",
  "sn.sinFirmaSigue":
    "Zonder handtekening gaat de inschrijving gewoon door, maar het lid blijft dan als «nog te tekenen» staan en kan het alsnog in het ledenportaal doen.",
  "sn.cuota": "Contributie",
  "sn.cuotaNota":
    "Elke lidmaatschapsvorm heeft zijn eigen contributie, korting en limieten. Die pas je aan bij Instellingen.",
  "sn.sinTipo": "Geen lidmaatschapsvorm",
  "sn.condicionesGenerales": "De algemene voorwaarden van de club",
  "sn.alAnio": "per jaar",
  "sn.alAnioLaDelClub": "per jaar · die van de club",
  "sn.descuentoCatalogo": "−{porcentaje}% op de catalogus",
  "sn.sinDescuento": "Geen korting",
  "sn.cobrarAhora": "Nu innen",
  "sn.sinCobrarla": "Zonder innen staat het lid in afwachting en kan het niets afhalen tot er betaald is.",
  "sn.formaDePago": "Betaalwijze",
  "sn.repaso": "Controle",
  "sn.r.nombre": "Naam",
  "sn.r.documento": "Document",
  "sn.r.nacimiento": "Geboortedatum",
  "sn.r.consumo": "Opgegeven verbruik",
  "sn.r.gMes": "{n} g/maand",
  "sn.r.avalista": "Voorgedragen door",
  "sn.r.sinAvalista": "Niet voorgedragen",
  "sn.r.tipo": "Lidmaatschapsvorm",
  "sn.r.rgpd": "AVG",
  "sn.r.firmado": "Getekend",
  "sn.r.pendiente": "In afwachting",
  "sn.r.contrato": "Contract",
  "sn.r.pendienteFirma": "Nog te tekenen",
  "sn.loQueSeCobra": "Wat er geïnd wordt",
  "sn.cuotaAnual": "Jaarcontributie",
  "sn.noSeCobraNada": "Er wordt nu niets geïnd: het lid blijft in afwachting.",
  "sn.nadaQueCobrar": "Er valt niets te innen.",
  "sn.seCobraEn": "Wordt geïnd via {forma}.",
  "sn.mini.socio": "Lid",
  "sn.mini.frente": "Voorkant",
  "sn.mini.reverso": "Achterkant",
  "sn.mini.firma": "Handtekening",
  "sn.sinFoto": "Geen foto",
  "sn.atras": "Terug",
  "sn.creando": "Aanmaken...",
  "sn.crear": "Lid aanmaken",
  "sn.siguiente": "Volgende",
  "sn.fallo": "Het lid kon niet worden aangemaakt",
  "sn.avisoSubida": "Het lid is aangemaakt, maar {que} kon niet worden geüpload.",
  "sn.subida.foto": "de foto van het lid",
  "sn.subida.frente": "de voorkant van het document",
  "sn.subida.reverso": "de achterkant van het document",
  "sn.subida.firma": "de handtekening",
  "sn.seAsigna": "(wordt bij aanmaken toegekend)",

  "se.titulo": "{socio} bewerken",
  "se.descripcion": "Lid nummer {numero}",
  "se.guardarCambios": "Wijzigingen opslaan",
  "se.datosPersonales": "Persoonsgegevens",
  "se.nombre": "Voornaam *",
  "se.apellidos": "Achternaam *",
  "se.tipoDocumento": "Soort document",
  "se.numero": "Nummer *",
  "se.nacimiento": "Geboortedatum *",
  "se.limitesPropios": "Eigen limieten",
  "se.sinLimites": "Laat je ze leeg, dan gelden die van de club.",
  "se.sinLimitesConCifras": "Laat je ze leeg, dan gelden die van de club ({diario} g per dag, {mensual} g per maand).",
  "se.limiteDiario": "Daglimiet (g)",
  "se.limiteMensual": "Maandlimiet (g)",
  "se.delClub": "Club: {cantidad}",
  "se.asociacion": "Vereniging",
  "se.tipoDeSocio": "Lidmaatschapsvorm",
  "se.sinTipo": "Geen vorm (voorwaarden van de club)",
  "se.avalista": "Voordragend lid",
  "se.buscarAvalista": "Voordragend lid zoeken...",
  "se.rgpd": "AVG-toestemming voor gegevensverwerking getekend",
  "se.fallo": "De wijzigingen konden niet worden opgeslagen",

  "lb.volver": "Terug naar leden",
  "lb.imprimir": "Afdrukken of opslaan als PDF",
  "lb.comoPdf":
    "Bij het afdrukken komt alleen het document eruit, zonder de menu's. Kies «Opslaan als PDF» bij de printerbestemming om het als PDF te bewaren.",
  "lb.titulo": "Ledenregister",
  "lb.emision": "Uittreksel opgemaakt op {fecha} door {quien}.",
  "lb.numero": "Nr.",
  "lb.apellidosNombre": "Achternaam en voornaam",
  "lb.documento": "Document",
  "lb.nacimiento": "Geboortedatum",
  "lb.alta": "Inschrijving",
  "lb.baja": "Uitschrijving",
  "lb.avalista": "Voorgedragen door",
  "lb.rgpd": "AVG",
  "lb.estado": "Status",
  "lb.numeroAvalista": "nr. {numero}",
  "lb.si": "Ja",
  "lb.sinSocios": "In het register staat nog geen enkel ingeschreven lid.",
  "lb.unInscrito": "1 ingeschreven lid",
  "lb.inscritos": "{n} ingeschreven leden",
  "lb.enTotal": "in totaal: {reparto}.",
  "lb.enAlta": "{n} ingeschreven",
  "lb.suspendidos": "{n} geschorst",
  "lb.pendientes": "{n} in afwachting van inschrijving",
  "lb.bajas": "{n} uitgeschreven",
  "lb.consentimiento": "Met getekende toestemming voor gegevensverwerking: {conConsentimiento} van {total}.",
  "lb.consumoDeclarado":
    "Verbruik dat de ingeschreven leden hebben opgegeven: {alMes} per maand, dat is {alAnio} per jaar. Dat is wat ze bij hun inschrijving zeiden nodig te hebben.",
  "lb.notaPie": "Intern document van de vereniging, opgemaakt uit haar ledenregister op de genoemde datum.",

  "cn.preparando": "De ledenpassen worden klaargezet...",
  "cn.falloPreparar": "De ledenpassen konden niet worden klaargezet.",
  "cn.volver": "Terug",
  "cn.unCarnet": "1 ledenpas",
  "cn.carnets": "{n} ledenpassen",
  "cn.cuantos": "{carnets}, op pasformaat: acht per A4-vel.",
  "cn.cuantosTodos": "{carnets} (alle actieve leden), op pasformaat: acht per A4-vel.",
  "cn.comoImprimir":
    "Bij het afdrukken komt alleen het vel met ledenpassen eruit, zonder de menu's; kies «Opslaan als PDF» bij de printerbestemming om het als PDF te bewaren.",
  "cn.elQr": "De QR is dezelfde als die van het ledenportaal: de balie leest hem net zo.",
  "cn.ninguno": "Er is geen enkel lid om af te drukken.",
  "cn.numero": "Nr. {numero}",
  "cn.validoHasta": "Geldig tot {fecha}",
  "cn.socioDesde": "Lid sinds {fecha}",
  "cn.documentoInterno": "Intern document van de vereniging",

  "si.titulo": "Leden importeren",
  "si.descripcion": "Haal het ledenregister op uit een ander programma of uit een spreadsheet",
  "si.volver": "Terug",
  "si.importadoUno": "1 lid geïmporteerd. Het staat nu in het register.",
  "si.importados": "{n} leden geïmporteerd. Ze staan nu in het register.",
  "si.verSocios": "Leden bekijken",
  "si.otroFichero": "Ander bestand importeren",
  "si.paso1": "1. Maak het bestand klaar",
  "si.explicacion":
    "Een CSV met één regel per lid. Minimaal nodig zijn «Nombre», «Apellidos», «Documento» en «Fecha nacimiento», in het Spaans of in het Catalaans. Staat er een kolom «Número», dan blijft het vertrouwde lidnummer behouden; zo niet, dan worden de eerstvolgende vrije nummers toegekend. De rest (telefoon, e-mail, adres, status, inschrijfdatum, lid tot, notities) wordt gebruikt als die er is. Het bestand dat dit programma zelf exporteert voldoet.",
  "si.explicacionNombreEntero":
    "Staan de voornaam en de achternaam samen in één kolom («Nombre y apellidos», «Nombre completo»), dan splits ik ze zelf en laat ik je de verdeling zien voordat er iets wordt opgeslagen.",
  "si.explicacionColumnasDobles":
    "En komen ze juist andersom, verdeeld over twee kolommen («Primer apellido» en «Segundo apellido», of «Primer nombre» en «Segundo nombre»), dan voeg ik ze samen.",
  "si.direccion": "Adres",
  "si.direccionJuntada":
    "Het adres stond verdeeld over meerdere kolommen («Calle», «Número», «Piso»…) en ik heb het op één regel samengevoegd, met voor elk stuk het woord dat jouw bestand gebruikt. Hier zie je het in zijn geheel.",
  "si.numeroEnLaCalle":
    "Let op met de kolom «Número»: omdat het bestand het adres verdeeld aanlevert, heb ik die gelezen als het huisnummer en niet als het lidnummer. De lidnummers worden vanaf het eerstvolgende vrije nummer toegekend. Als in die kolom jouw lidnummers stonden, geef de kolom met het huisnummer dan een andere naam («Número calle») en upload het bestand opnieuw.",
  "si.explicacionVarios":
    "Zijn er meerdere kolommen voor hetzelfde («Teléfono 1» en «Teléfono 2»), dan houd ik de eerste aan: van een lid wordt één telefoonnummer bewaard, geen drie.",
  "si.explicacionDireccion":
    "Het adres mag verdeeld staan over «Calle», «Número», «Piso» en «Puerta», en de DNI over nummer en letter: die voeg ik zelf samen.",
  "si.formatos":
    "Datums in de notatie 2026-09-01 of 01/09/2026. Scheidingsteken «;» of «,». Bestanden die door Excel zijn opgeslagen worden in al zijn tekencoderingen geaccepteerd.",
  "si.descargarPlantilla": "Sjabloon downloaden",
  "si.falloPlantilla": "Het sjabloon kon niet worden gedownload",
  "si.paso2": "2. Kies het bestand en analyseer het",
  "si.analizarNoGuarda": "Analyseren slaat niets op: het controleert alleen het bestand en zegt je wat het vindt.",
  "si.analizando": "Bezig met analyseren...",
  "si.analizar": "Analyseren",
  "si.paso3": "3. Resultaat",
  "si.procesando": "Het bestand wordt verwerkt...",
  "si.eligeFichero": "Kies een bestand en druk op Analyseren.",
  "si.filas": "Rijen",
  "si.validas": "Geldig",
  "si.conErrores": "Met fouten",
  "si.columnas": "Herkende kolommen: {columnas}",
  "si.corrige":
    "Verbeter deze rijen in het bestand en analyseer het opnieuw. Er wordt niets geïmporteerd zolang er fouten zijn.",
  "si.fila": "Rij",
  "si.problema": "Probleem",
  "si.numero": "Nr.",
  "si.socio": "Lid",
  "si.nombre": "Voornaam",
  "si.apellidos": "Achternaam",
  "si.columnasJuntadas":
    "Het bestand levert de achternaam (of de voornaam) verdeeld over twee kolommen aan en ik heb die tot één samengevoegd. Hier valt niets te raden, het komt eruit zoals het binnenkwam; kijk het toch even na om te bevestigen dat dit de volgorde is die je verwachtte.",
  "si.nombrePartido":
    "Het bestand levert de voornaam en de achternaam in dezelfde kolom aan en ik heb die gesplitst. Er gaat geen stuk van de naam verloren, maar waar de voornaam ophoudt en de achternaam begint is een aanname van mij. Loop het hier na voordat je importeert: is er een verkeerd verdeeld, dan los je dat op door het lid te bewerken.",
  "si.documento": "Document",
  "si.estado": "Status",
  "si.seMuestran": "Er worden {cuantos} van {total} getoond.",
  "si.importarUno": "1 lid importeren",
  "si.importarVarios": "{n} leden importeren",
  "si.falloLeer": "Het bestand kon niet worden gelezen",
  "si.falloImportar": "Importeren is niet gelukt",

  "sf.volver": "Terug",
  "sf.carnet": "Ledenpas",
  "sf.editar": "Gegevens bewerken",
  "sf.dispensar": "Verstrekken",
  "sf.unAnio": "1 jaar",
  "sf.anios": "{n} jaar",
  "sf.subiendo": "Bezig met uploaden...",
  "sf.cambiarFoto": "Foto wijzigen",
  "sf.anadirFoto": "Foto toevoegen",
  "sf.quitarFoto": "Foto verwijderen",
  "sf.falloQuitarFoto": "De foto kon niet worden verwijderd",
  "sf.documento": "Document",
  "sf.alta": "Inschrijving",
  "sf.cuotaHasta": "Lid tot",
  "sf.avalista": "Voorgedragen door",
  "sf.rgpd": "AVG-toestemming",
  "sf.portal": "Ledenportaal",
  "sf.activo": "Actief",
  "sf.sinAcceso": "Geen toegang",
  "sf.cartera": "Tegoed",
  "sf.recargar": "Opwaarderen",
  "sf.cobrarCuota": "Contributie innen",
  "sf.devolverSaldo": "Saldo terugbetalen",
  "sf.ajustarSaldo": "Saldo corrigeren",
  "sf.suspender": "Tijdelijk schorsen",
  "sf.levantar": "Schorsing opheffen",
  "sf.falloLevantar": "Opheffen is niet gelukt",
  "sf.reactivar": "Lid heractiveren",
  "sf.falloReactivar": "Heractiveren is niet gelukt",
  "sf.renovarPortal": "Portaaltoegang verlengen",
  "sf.darPortal": "Portaaltoegang geven",
  "sf.falloCodigo": "De code kon niet worden aangemaakt",
  "sf.retirarPortal": "Portaaltoegang intrekken",
  "sf.falloRetirar": "De toegang kon niet worden ingetrokken",
  "sf.darDeBaja": "Uitschrijven",
  "sf.descargarDatos": "Gegevens downloaden",
  "sf.falloDescargar": "De gegevens konden niet worden gedownload",
  "sf.borrarDatos": "Gegevens wissen",
  "sf.consumoYLimites": "Verbruik en limieten",
  "sf.hoy": "Vandaag",
  "sf.esteMes": "Deze maand",
  "sf.puedeRetirar": "Kan nu afhalen",
  "sf.consumoDeclarado": "Verbruik opgegeven bij de inschrijving",
  "sf.alMes": "{cantidad}/maand",
  "sf.tab.resumen": "Overzicht",
  "sf.tab.dispensaciones": "Verstrekkingen",
  "sf.tab.cartera": "Mutaties",
  "sf.tab.cuotas": "Contributies",
  "sf.entregasRegistradas": "Geregistreerde verstrekkingen",
  "sf.ultimaVisita": "Laatste bezoek",
  "sf.cuotasPagadas": "Betaalde contributies",
  "sf.notas": "Interne notities",
  "sf.avalados": "Voorgedragen leden",
  "sf.sinDispensaciones": "Dit lid heeft nog geen product afgehaald.",
  "sf.fecha": "Datum",
  "sf.productos": "Producten",
  "sf.cantidad": "Hoeveelheid",
  "sf.importe": "Bedrag",
  "sf.anulada": "Geannuleerd",
  "sf.sinCartera": "Geen tegoedmutaties.",
  "sf.concepto": "Omschrijving",
  "sf.saldo": "Saldo",
  "sf.sinCuotas": "Geen contributies geregistreerd.",
  "sf.validaHasta": "Lid tot",
  "sf.codigoPortal": "Code voor het ledenportaal",
  "sf.hecho": "Klaar",
  "sf.daleLosDatos": "Geef deze gegevens aan het lid. De code verloopt over 7 dagen en werkt maar één keer.",
  "sf.numeroDeSocio": "Lidnummer",
  "sf.codigo": "Code",
  "sf.entraEn": "Ga naar {url} en kies «Mijn toegang activeren».",
  "sf.devolverTitulo": "Saldo aan het lid terugbetalen",
  "sf.devolverEtiqueta": "Terug te betalen bedrag",
  "sf.ajustarTitulo": "Saldo corrigeren",
  "sf.ajustarEtiqueta": "Bedrag van de correctie (negatief om af te trekken)",
  "sf.bajaTitulo": "Het lid uitschrijven",
  "sf.bajaTexto":
    "Het lid kan dan geen product meer afhalen. De historie blijft bewaard. Staat er nog saldo op het tegoed, dan moet dat eerst worden terugbetaald.",
  "sf.suspenderTitulo": "Tijdelijk schorsen",
  "sf.suspenderTexto":
    "Zolang het lid geschorst is, kan het niet inloggen en geen product afhalen. Je heft de schorsing op vanaf deze zelfde pagina.",
  "sf.suspenderBoton": "Schorsen",
  "sf.comoMaximo": "Maximaal {importe} credits.",
  "sf.confirmar": "Bevestigen",
  "sf.motivoObligatorio": "Reden (verplicht)",
  "sf.motivo": "Reden",
  "sf.formaDePago": "Betaalwijze",
  "sf.falloAccion": "De actie kon niet worden voltooid",
  "sf.borrarTitulo": "De gegevens van het lid wissen",
  "sf.borrando": "Bezig met wissen...",
  "sf.sinVuelta": "Dit kun je niet terugdraaien.",
  "sf.seBorra": "Dit wordt gewist:",
  "sf.seBorraLista":
    "voornaam, achternaam, document, geboortedatum, telefoon, e-mail, adres, foto, notities en de toegang tot het portaal.",
  "sf.seConserva": "Dit blijft bewaard:",
  "sf.seConservaLista":
    "het lidnummer en de verstrekkingen, contributies, tegoedmutaties en bezoeken. Dat zijn de boekhouding en de traceerbaarheid van de club, en ze wissen zou de boeken uit balans brengen en het spoor van de partijen verbreken. Ze blijven staan zonder naam erachter.",
  "sf.copiasDeSeguridad":
    "In de back-ups van vóór vandaag staan de gegevens nog: die verdwijnen zodra de back-ups verlopen. Moet het in jullie geval verder gaan, overleg dat dan met jullie adviseur.",
  "sf.escribeNumero": "Typ het lidnummer ({numero}) om te bevestigen",
  "sf.falloBorrar": "De gegevens konden niet worden gewist",
  "sf.frente": "Voorkant",
  "sf.reverso": "Achterkant",
  "sf.sinFoto": "Geen foto",
  "sf.cambiar": "Wijzigen",
  "sf.subir": "Uploaden",

  "cu.titulo": "Contributies",
  "cu.descripcion": "Wat er aan contributie is geïnd, en welke lidmaatschapsvormen er zijn",
  "cu.a": "t/m",
  "cu.exportar": "CSV exporteren",
  "cu.falloExportar": "Exporteren is niet gelukt",
  "cu.tabCobradas": "Geïnd",
  "cu.tabTipos": "Lidmaatschapsvormen",
  "cu.cobradoEnPeriodo": "Geïnd in de periode",
  "cu.unaCuota": "1 contributie",
  "cu.cuotas": "{n} contributies",
  "cu.altas": "Inschrijvingen",
  "cu.altasPie": "Eerste contributies: nieuwe leden",
  "cu.enEfectivo": "Contant",
  "cu.enEfectivoPie": "Komt in de kassa van de kassadienst",
  "cu.buscar": "Zoeken op lid, DNI of omschrijving",
  "cu.altasYRenovaciones": "Inschrijvingen en verlengingen",
  "cu.soloAltas": "Alleen inschrijvingen",
  "cu.soloRenovaciones": "Alleen verlengingen",
  "cu.cualquierTipo": "Elke lidmaatschapsvorm",
  "cu.cualquierForma": "Elke betaalwijze",
  "cu.cualquierPuesto": "Elke werkplek",
  "cu.sinCoincidencias":
    "Geen enkele contributie geïnd met deze filters. Om te zien wie aan de beurt is om te betalen,",
  "cu.miraRenovaciones": "kijk bij Verlengingen",
  "cu.fecha": "Datum",
  "cu.socio": "Lid",
  "cu.tipoDeSocio": "Lidmaatschapsvorm",
  "cu.altaORenovacion": "Inschrijving of verlenging",
  "cu.periodo": "Periode",
  "cu.forma": "Betaalwijze",
  "cu.puesto": "Werkplek",
  "cu.cobro": "Geïnd door",

  "cu.an.boton": "Annuleren",
  "cu.an.anulada": "Geannuleerd",
  "cu.an.titulo": "Een contributie van {importe} annuleren",
  "cu.an.queVaAPasar":
    "{socio} krijgt {importe} terug en de contributie telt niet meer mee: de datum tot wanneer het lid betaald heeft gaat terug naar de vorige contributie, en als dit de enige was kan het lid niets meer afhalen tot er opnieuw betaald wordt.",
  "cu.an.deLaCartera": "Het is met het tegoed betaald, dus dat komt er direct weer bij.",
  "cu.an.delCajon":
    "Het is contant betaald, dus het geld gaat uit de lade waar het in kwam. Is die dienst al afgesloten, dan wordt er geen enkele kassa aangeraakt: die telling is al vastgelegd met deze contributie erin.",
  "cu.an.motivo": "Reden",
  "cu.an.motivoAyuda":
    "Dit wordt vastgelegd. Over een half jaar is het het enige dat dit verklaart.",
  "cu.an.confirmar": "Contributie annuleren",
  "cu.an.anulando": "Annuleren…",
  "cu.an.fallo": "Kon de contributie niet annuleren",
  "cu.importe": "Bedrag",
  "cu.alta": "Inschrijving",
  "cu.renovacion": "Verlenging",
  "cu.tiposTitulo": "Lidmaatschapsvormen",
  "cu.tiposNota": "Elke vorm heeft zijn eigen contributie, looptijd, korting en limieten.",
  "cu.seEditanEnAjustes": "Je maakt en bewerkt ze bij Instellingen",
  "cu.sinTipos": "Geen lidmaatschapsvormen. Iedereen betaalt de algemene contributie van de club.",
  "cu.sinTiposConCuota":
    "Geen lidmaatschapsvormen. Iedereen betaalt de algemene contributie van de club, {importe} per jaar.",
  "cu.tipo": "Vorm",
  "cu.cuota": "Contributie",
  "cu.dura": "Duur",
  "cu.descuento": "Korting",
  "cu.socios": "Leden",
  "cu.apagado": " · uit",
  "cu.laDelClub": "die van de club",
  "cu.unAnio": "1 jaar",
  "cu.anios": "{n} jaar",
  "cu.unMes": "1 maand",
  "cu.meses": "{n} maanden",

  "rn.titulo": "Verlengingen",
  "rn.descripcion": "Leden van wie het lidmaatschap is verlopen of bijna verloopt",
  "rn.vencenEnDias": "Verlopen over {dias}",
  "rn.cuotaVencida": "Lidmaatschap verlopen",
  "rn.noPuedenRetirar": "Kunnen niets afhalen",
  "rn.convieneAvisar": "Stuur ze een herinnering",
  "rn.cuotaAnual": "Jaarcontributie",
  "rn.nadieVencida": "Bij niemand is het lidmaatschap verlopen.",
  "rn.vencenEnLosProximos": "Verlopen in de komende {dias}",
  "rn.ningunaVence": "Er verloopt geen lidmaatschap in de komende {dias}.",
  "rn.laAsociacion": "de vereniging",
  "rn.cobrada": "Contributie van {socio} geïnd. Lidmaatschap loopt tot {fecha}.",
  "rn.socio": "Lid",
  "rn.telefono": "Telefoon",
  "rn.estado": "Status",
  "rn.cuotaHasta": "Lid tot",
  "rn.whatsapp": "WhatsApp",
  "rn.mensajeWhatsapp":
    "Hoi {nombre}, dit is een bericht van {club}. Je lidmaatschap moet verlengd worden. Kom langs in de club wanneer het je uitkomt. Bedankt.",
  "rn.sinCuota": "Geen contributie",
  "rn.vencioHace": "{dias} geleden verlopen",
  "rn.venceHoy": "verloopt vandaag",
  "rn.queda": "nog {dias}",
  "rn.quedan": "nog {dias}",
  "rn.cobrarCuota": "Contributie innen",
  "rn.nadieAQuienAvisar":
    "Er was niemand om te herinneren: ze zijn hier al aan herinnerd, of hun lidmaatschap verloopt nog niet.",
  "rn.avisadoUno": "1 lid herinnerd ({porCorreo} per e-mail, {porMovil} op de mobiel).",
  "rn.avisados": "{n} leden herinnerd ({porCorreo} per e-mail, {porMovil} op de mobiel).",
  "rn.unoSinCorreo": "1 lid zonder e-mailadres in de gegevens.",
  "rn.sinCorreo": "{n} leden zonder e-mailadres in de gegevens.",
  "rn.falloRecordatorios": "De herinneringen konden niet worden verstuurd",
  "rn.enviando": "Versturen...",
  "rn.avisar": "Leden met een verlopend lidmaatschap herinneren",

  "gc.gastos": "Uitgaven",
  "gc.compras": "Inkopen",
  "gc.proveedores": "Leveranciers",

  "pago.DOMICILIADO": "Automatische incasso",

  "ga.titulo": "Uitgaven en inkopen",
  "ga.descripcion": "Wat de vereniging uitgeeft, met categorie",
  "ga.a": "t/m",
  "ga.categorias": "Categorieën",
  "ga.exportar": "CSV exporteren",
  "ga.falloExportar": "Exporteren is niet gelukt",
  "ga.nuevo": "+ Uitgave",
  "ga.totalFiltrado": "Totaal van de selectie",
  "ga.totalPeriodo": "Totaal van de periode",
  "ga.unApunte": "1 boeking",
  "ga.apuntes": "{n} boekingen",
  "ga.enEfectivo": "Contant",
  "ga.saleDeCaja": "Gaat uit de kassa van vandaag",
  "ga.categoriaMayor": "Grootste categorie",
  "ga.porCategoria": "Per categorie",
  "ga.sinGastos": "Geen uitgaven in deze periode.",
  "ga.gastosDe": "Uitgaven in {categoria}",
  "ga.todosLosGastos": "Alle uitgaven",
  "ga.buscar": "Zoeken op omschrijving, leverancier of notitie",
  "ga.todasCategorias": "Alle categorieën",
  "ga.apagada": " (uit)",
  "ga.cualquierForma": "Elke betaalwijze",
  "ga.cualquierPuesto": "Elke werkplek",
  "ga.conPagosProveedor": "Inclusief betalingen aan leveranciers",
  "ga.verAnulados": "Geannuleerde tonen",
  "ga.sinCoincidencias": "Geen uitgaven met deze filters.",
  "ga.sinApuntes": "Er zijn geen uitgaven geboekt in deze periode.",
  "ga.numero": "Nr.",
  "ga.fecha": "Datum",
  "ga.concepto": "Omschrijving",
  "ga.categoria": "Categorie",
  "ga.pago": "Betaling",
  "ga.puesto": "Werkplek",
  "ga.importe": "Bedrag",
  "ga.compraNumero": " · Inkoop #{numero}",
  "ga.anulado": "Geannuleerd",
  "ga.anuladoPor": "Geannuleerd: {motivo}",
  "ga.editar": "Bewerken",
  "ga.anular": "Annuleren",
  "ga.d.editar": "Uitgave bewerken",
  "ga.d.nuevo": "Nieuwe uitgave",
  "ga.d.fallo": "De uitgave kon niet worden opgeslagen",
  "ga.d.concepto": "Omschrijving",
  "ga.d.conceptoEjemplo": "Elektriciteitsrekening",
  "ga.d.importe": "Bedrag (credits)",
  "ga.d.fecha": "Datum",
  "ga.d.categoria": "Categorie",
  "ga.d.formaDePago": "Betaalwijze",
  "ga.d.saldraDeCaja": "Gaat uit de open kassa.",
  "ga.d.proveedor": "Leverancier",
  "ga.d.notas": "Notities",
  "ga.d.editarNota":
    "Een uitgave bewerken verandert niets aan de kassamutatie die destijds is geboekt: de kasopmaak van die kassadienst is al afgesloten.",
  "ga.an.titulo": "Uitgave #{numero} annuleren",
  "ga.an.fallo": "Annuleren is niet gelukt",
  "ga.an.motivo": "Reden",
  "ga.an.motivoAyuda": "Blijft bij de uitgave staan, zodat het duidelijk is als je de maand nakijkt.",
  "ga.an.motivoEjemplo": "Het bedrag klopte niet",
  "ga.an.noSeBorra": "Hij wordt niet verwijderd: hij blijft doorgestreept in de lijst staan.",
  "ga.an.vuelveALaCaja": " Het geld gaat terug naar de open kassa.",
  "ga.an.compraNoPagada": " Inkoop #{numero} staat dan weer als niet betaald.",
  "ga.c.titulo": "Uitgavencategorieën",
  "ga.c.listo": "Klaar",
  "ga.c.fallo": "Niet gelukt",
  "ga.c.ejemplo": "Water, Lonen, Boekhouding...",
  "ga.c.anadir": "Toevoegen",
  "ga.c.unGasto": "1 uitgave",
  "ga.c.gastos": "{n} uitgaven",
  "ga.c.apagadaNota": "Uit · wordt niet aangeboden bij het boeken",
  "ga.c.seApagara": "Wordt uitgezet: er zitten uitgaven in",
  "ga.c.quitarla": "Verwijderen",
  "ga.c.quitar": "Verwijderen",
  "ga.c.volverAUsar": "Weer gebruiken",
  "ga.c.nota":
    "Een categorie met uitgaven erin wordt uitgezet in plaats van verwijderd: zo blijven de boekingen van eerdere jaren zeggen waar ze over gingen.",

  "co.titulo": "Uitgaven en inkopen",
  "co.descripcion": "Bestellingen bij de leverancier, wat binnenkomt en wat nog openstaat",
  "co.nuevaCompra": "+ Inkoop",
  "co.nuevoProveedor": "+ Leverancier",
  "co.antesDeLaPrimera":
    "Voor de eerste inkoop moet de leverancier worden toegevoegd, zodat hij niet zomaar een losse naam blijft en je kunt zien wat hij heeft gebracht en wat je hem nog schuldig bent.",
  "co.pendienteDePagar": "Nog te betalen",
  "co.aTodos": "Aan alle leveranciers",
  "co.pedidasSinRecibir": "Besteld, niet ontvangen",
  "co.enCamino": "Besteld en nog onderweg",
  "co.sinProveedores": "Er zijn nog geen leveranciers.",
  "co.proveedor": "Leverancier",
  "co.contacto": "Contact",
  "co.compras": "Inkopen",
  "co.seLeDebe": "Openstaand",
  "co.sinCompras":
    "Er zijn nog geen inkopen. Zodra je er een ontvangt, komen de producten vanzelf in het magazijn met hun kostprijs en hun leverancier, zonder ze opnieuw in Voorraadbeheer te typen.",
  "co.pedida": "Besteld",
  "co.recibida": "Ontvangen",
  "co.anulada": "Geannuleerd",
  "co.debe": "Openstaand {importe}",
  "co.pagada": "Betaald",
  "co.recibidaEl": " · ontvangen op {fecha}",
  "co.noEsGenero": " · geen voorraadartikel",
  "co.haLlegado": "Ontvangen",
  "co.anular": "Annuleren",
  "co.an.titulo": "Inkoop #{numero} annuleren",
  "co.an.quePasa":
    "De inkoop wordt geannuleerd en telt niet meer mee in wat je de leverancier schuldig bent. De voorraad blijft ongemoeid: hij was nog niet binnen.",
  "co.an.motivo": "Reden (optioneel)",
  "co.an.confirmar": "Inkoop annuleren",
  "co.an.fallo": "De inkoop kon niet worden geannuleerd",
  "co.an.hecho": "Inkoop #{numero} geannuleerd",
  "co.pagar": "Betalen",
  "co.recibidaConLotes": "Inkoop #{numero} ontvangen. {lotes} in het magazijn.",
  "co.recibidaSinLotes": "Inkoop #{numero} ontvangen.",
  "co.unLote": "1 partij",
  "co.lotes": "{n} partijen",
  "co.falloRecibir": "Ontvangen is niet gelukt",
  "co.p.titulo": "Nieuwe leverancier",
  "co.p.fallo": "Opslaan is niet gelukt",
  "co.p.nombre": "Naam",
  "co.p.cif": "CIF of NIF",
  "co.p.telefono": "Telefoon",
  "co.p.email": "E-mail",
  "co.p.notas": "Notities",
  "co.n.titulo": "Nieuwe inkoop",
  "co.n.fallo": "De inkoop kon niet worden opgeslagen",
  "co.n.registrar": "Vastleggen · {importe}",
  "co.n.proveedor": "Leverancier",
  "co.n.referencia": "Pakbon of factuur",
  "co.n.referenciaAyuda": "Optioneel, het nummer dat op het papier staat.",
  "co.n.queSeCompra": "Wat je inkoopt",
  "co.n.explicacion":
    "Regels die naar een product uit de catalogus wijzen, maken hun partij aan zodra de inkoop binnen is. De rest —potjes, etiketten, een weegschaal— is uitgave en raakt de voorraad niet.",
  "co.n.producto": "Product",
  "co.n.noEsGenero": "Geen voorraadartikel",
  "co.n.descripcion": "Omschrijving",
  "co.n.gramos": "Gram",
  "co.n.coste": "Kostprijs (credits)",
  "co.n.otraLinea": "+ Nog een regel",
  "co.n.quitarUltima": "Laatste verwijderen",
  "co.g.titulo": "Inkoop #{numero} betalen",
  "co.g.fallo": "De betaling kon niet worden vastgelegd",
  "co.g.registrar": "Betaling vastleggen",
  "co.g.quedanPorPagar": "Van deze inkoop staat nog {importe} open bij {proveedor}.",
  "co.g.importe": "Bedrag (credits)",
  "co.g.aPlazos": "Je kunt in termijnen betalen.",
  "co.g.formaDePago": "Betaalwijze",
  "co.g.comoGasto":
    "De betaling wordt geboekt als uitgave gekoppeld aan deze inkoop, zodat het geld maar één keer uit de boeken gaat.",
  "co.g.enEfectivo": "Contant gaat het uit de kassa van de kassadienst.",

  "do.titulo": "Donaties en stortingen",
  "do.descripcion": "Wat mensen aan de club geven en wat ze op hun tegoed zetten om binnen te besteden",
  "do.a": "t/m",
  "do.exportar": "CSV exporteren",
  "do.falloExportar": "Exporteren is niet gelukt",
  "do.nueva": "+ Donatie",
  "do.tabDonaciones": "Donaties",
  "do.tabCartera": "Stortingen op tegoed",
  "do.deSuCartera": "Van het tegoed",
  "do.donadoEnPeriodo": "Gedoneerd in de periode",
  "do.unaDonacion": "1 donatie",
  "do.donaciones": "{n} donaties",
  "do.sinNombre": "Zonder naam",
  "do.delBote": "Uit de pot, zonder lid erachter",
  "do.enEfectivo": "Contant",
  "do.entraEnCaja": "Komt in de kassa van de kassadienst",
  "do.ingresadoEnPeriodo": "Gestort in de periode",
  "do.unIngreso": "1 storting",
  "do.ingresos": "{n} stortingen",
  "do.clubDebe": "Wat de club nu schuldig is",
  "do.saldoVivo": "Openstaand saldo op alle tegoeden",
  "do.buscar": "Zoeken op lid of omschrijving",
  "do.cualquierForma": "Elke betaalwijze",
  "do.cualquierPuesto": "Elke werkplek",
  "do.verAnuladas": "Geannuleerde tonen",
  "do.sinDonaciones":
    "Geen donatie met deze filters. Ze zijn om het geld te boeken dat iemand aan de club geeft, los van zijn contributie en van wat hij afhaalt.",
  "do.numero": "Nr.",
  "do.fecha": "Datum",
  "do.quien": "Wie",
  "do.concepto": "Omschrijving",
  "do.forma": "Betaalwijze",
  "do.puesto": "Werkplek",
  "do.atendio": "Geholpen door",
  "do.importe": "Bedrag",
  "do.anonima": "Anoniem",
  "do.anulada": "Geannuleerd",
  "do.anular": "Annuleren",
  "do.sinIngresos":
    "Niemand heeft geld op zijn tegoed gezet met deze filters. Stortingen doe je vanuit de gegevens van het lid of vanaf de balie.",
  "do.socio": "Lid",
  "do.loCobro": "Geïnd door",
  "do.ingresado": "Gestort",
  "do.saldoDespues": "Saldo daarna",
  "do.sinDato": "Onbekend",
  "do.r.titulo": "Een donatie vastleggen",
  "do.r.fallo": "De donatie kon niet worden vastgelegd",
  "do.r.registrar": "Registreren",
  "do.r.quienDona": "Wie doneert",
  "do.r.quienDonaAyuda": "Mag je leeg laten: er zijn mensen die geld in de pot doen zonder hun naam te noemen.",
  "do.r.quitar": "Verwijderen",
  "do.r.buscarSocio": "Zoek een lid, of laat het leeg",
  "do.r.importe": "Bedrag (credits)",
  "do.r.formaDePago": "Betaalwijze",
  "do.r.faltaSocio": "Om vanaf het tegoed te doneren moet je zeggen van welk lid.",
  "do.r.efectivoNota": "Komt in de kassa van de kassadienst. De andere betaalwijzen raken die niet.",
  "do.r.concepto": "Omschrijving",
  "do.r.conceptoAyuda": "Optioneel. Bijvoorbeeld: pot van de bar, loterij, extra bijdrage.",
  "do.an.titulo": "De donatie annuleren",
  "do.an.fallo": "Annuleren is niet gelukt",
  "do.an.anulando": "Annuleren...",
  "do.an.anular": "Annuleren",
  "do.an.explicacion":
    "Er wordt {importe} geannuleerd. De donatie wordt niet verwijderd: hij wordt als geannuleerd gemarkeerd en telt niet meer mee in de boeken. Een storting die uit de historie verdwijnt, is een gat in de kasopmaak.",
  "do.an.efectivo": "Het geld gaat uit de open kassa met een eigen boeking.",
  "do.an.cartera": "Het saldo gaat terug naar het lid.",
  "do.an.motivo": "Reden",
  "do.an.motivoAyuda": "Optioneel, maar het helpt om het over zes maanden nog te begrijpen.",

  "semana.1c": "ma",
  "semana.2c": "di",
  "semana.3c": "wo",
  "semana.4c": "do",
  "semana.5c": "vr",
  "semana.6c": "za",
  "semana.0c": "zo",
  "semana.1": "Maandag",
  "semana.2": "Dinsdag",
  "semana.3": "Woensdag",
  "semana.4": "Donderdag",
  "semana.5": "Vrijdag",
  "semana.6": "Zaterdag",
  "semana.0": "Zondag",

  "de.titulo": "Kortingen",
  "de.descripcion": "Acties per categorie, product, lidmaatschapsvorm, dag en tijdvak",
  "de.nuevo": "+ Korting",
  "de.unoSolo": "één korting, de hoogste",
  "de.noSeAcumulan":
    "die past: ze zijn onderling niet te combineren en ook niet met de algemene korting van de lidmaatschapsvorm.",
  "de.enCadaEntrega": "Bij elke verstrekking geldt",
  "de.sinDescuentos": "Er zijn nog geen kortingen. Maak er een voor bijvoorbeeld een middag met 15% op bloemen.",
  "de.nombre": "Naam",
  "de.descuento": "Korting",
  "de.aplicaA": "Geldt voor",
  "de.cuando": "Wanneer",
  "de.estado": "Status",
  "de.categoriaNombre": "Categorie {nombre}",
  "de.todoElCatalogo": "Hele catalogus",
  "de.soloTipo": "Alleen {tipo}",
  "de.todosLosDias": "Alle dagen",
  "de.activo": "Actief",
  "de.apagado": "Uit",
  "de.editar": "Bewerken",
  "de.borrar": "Verwijderen",
  "de.falloBorrar": "Verwijderen is niet gelukt",
  "de.d.editar": "{nombre} bewerken",
  "de.d.nuevo": "Nieuwe korting",
  "de.d.fallo": "De korting is niet opgeslagen",
  "de.d.nombre": "Naam",
  "de.d.nombreAyuda": "Staat op de bon, bijv. «Rustige middag».",
  "de.d.porcentaje": "Korting (%)",
  "de.d.categoria": "Categorie",
  "de.d.categoriaAyuda": "Leeg = alle.",
  "de.d.todas": "Alle",
  "de.d.producto": "Eén bepaald product",
  "de.d.productoAyuda": "Leeg = alle uit de categorie.",
  "de.d.todos": "Alle",
  "de.d.tipoSocio": "Alleen voor één lidmaatschapsvorm",
  "de.d.tipoSocioAyuda": "Leeg = voor iedereen.",
  "de.d.todosLosSocios": "Alle leden",
  "de.d.dias": "Dagen van de week",
  "de.d.diasAyuda": "Niets aangevinkt = alle dagen.",
  "de.d.desdeLas": "Vanaf",
  "de.d.franjaAyuda": "Tijdvak; leeg = de hele dag.",
  "de.d.hastaLas": "Tot",
  "de.d.fechaInicio": "Startdatum",
  "de.d.fechaAyuda": "Leeg = onbeperkt.",
  "de.d.fechaFin": "Einddatum",
  "de.d.activo": "Actief",

  "ca.titulo": "Kaarten",
  "ca.descripcion": "Wat de leden zien op het scherm in de club of als ze een QR scannen",
  "ca.dispensario": "Balie",
  "ca.barra": "Bar",
  "ca.sinCartaBarra": "Nog geen barkaart. Als jullie drank of eten hebben, laat je hier de lijst zien.",
  "ca.sinCartaDispensario": "Nog geen baliekaart.",
  "ca.principalAyuda": "Die op het scherm in de club staat",
  "ca.principal": "★ Hoofdkaart",
  "ca.apagada": "Uit",
  "ca.creadaEl": "Aangemaakt op {fecha}",
  "ca.nCategorias": " · {n} categorieën",
  "ca.verQr": "QR en link bekijken",
  "ca.qr": "QR",
  "ca.editar": "Bewerken",
  "ca.nuevaDe": "+ Kaart voor {zona}",
  "ca.laPrincipal": "hoofdkaart",
  "ca.notaPrincipal1": "De",
  "ca.notaPrincipal2":
    "van elke zone is wat er op het scherm in de club staat. De rest open je met een eigen link, om een QR op de tafels te leggen of naar iemand te sturen.",
  "ca.fallo": "Niet gelukt",
  "ca.n.titulo": "Nieuwe kaart",
  "ca.n.nombreBarra": "Barkaart",
  "ca.n.nombreDispensario": "Baliekaart",
  "ca.n.crear": "Aanmaken",
  "ca.n.fallo": "Aanmaken is niet gelukt",
  "ca.n.nombre": "Naam",
  "ca.n.nombreAyuda": "Alleen jullie zien dit, om ze uit elkaar te houden.",
  "ca.n.avisoBarra": "Toont alles wat jullie bij de bar hebben ingevoerd.",
  "ca.n.avisoDispensario": "Toont alles met voorraad. Daarna kun je hem beperken tot bepaalde categorieën.",
  "ca.e.nombre": "Naam",
  "ca.e.mensaje": "Bericht",
  "ca.e.mensajeAyuda": "Staat helemaal bovenaan. Bijvoorbeeld: openingstijden, of iets nieuws.",
  "ca.e.categorias": "Categorieën die de kaart toont",
  "ca.e.categoriasAyuda": "Niets aangevinkt: dan worden ze allemaal getoond.",
  "ca.e.encendida": "Aan",
  "ca.e.encendidaAyuda": "Staat hij uit, dan opent de link niet meer. Er wordt niets verwijderd.",
  "ca.e.ponerlaEnPantalla": "Op het scherm in de club zetten",
  "ca.e.hacerlaPrincipal": "★ Hoofdkaart maken",
  "ca.e.yaNoLaUsais": "Niet meer in gebruik",
  "ca.e.confirmarBorrar": "Kaart «{nombre}» verwijderen? De link opent daarna niet meer.",
  "ca.e.borrar": "Verwijderen",
  "ca.e.falloBorrar": "Verwijderen is niet gelukt",
  "ca.e.falloGuardar": "Opslaan is niet gelukt",
  "ca.q.titulo": "QR van {nombre}",
  "ca.q.apagada": "Deze kaart staat uit: de link opent pas als je hem aanzet.",
  "ca.q.enlace": "Link",
  "ca.q.siSeHaFiltrado": "Als de link is uitgelekt",
  "ca.q.confirmarRenovar": "Er komt een nieuwe link en de huidige opent niet meer. Doorgaan?",
  "ca.q.cambiarEnlace": "Link vervangen",
  "ca.q.soloEsta": "Alleen die van deze kaart verandert. De andere blijven werken.",

  "pd.volver": "Terug",
  "pd.entradasYMermas": "Ontvangsten en derving",
  "pd.stock": "Voorraad",
  "pd.minimo": "Minimaal {cantidad}",
  "pd.sinMinimo": "Geen minimum ingesteld",
  "pd.aportacion": "Bijdrage",
  "pd.costeMedio": "Gemiddelde kostprijs",
  "pd.sinCoste": "De partijen hebben geen kostprijs",
  "pd.segunLotes": "Op basis van de partijen met kostprijs",
  "pd.thcCbd": "THC / CBD",
  "pd.disponible": "Beschikbaar op de balie",
  "pd.retirado": "Van de balie gehaald",
  "pd.lotes": "Partijen",
  "pd.sinLotes":
    "Dit product heeft geen partijen: de voorraad is er met een voorraadcorrectie in gezet, zonder herkomst.",
  "pd.lote": "Partij",
  "pd.entrada": "Ontvangst",
  "pd.origen": "Herkomst",
  "pd.inicial": "Begin",
  "pd.queda": "Over",
  "pd.coste": "Kostprijs",
  "pd.caducidad": "Houdbaar tot",
  "pd.estado": "Status",
  "pd.consumido": "{n}% verbruikt",
  "pd.agotado": "Op",
  "pd.caducado": "Verlopen",
  "pd.enUso": "In gebruik",
  "pd.ultimosMovimientos": "Laatste mutaties",
  "pd.sinMovimientos": "Geen mutaties.",
  "pd.fecha": "Datum",
  "pd.tipo": "Type",
  "pd.detalle": "Details",
  "pd.cantidad": "Hoeveelheid",
  "pd.stockDespues": "Voorraad daarna",
  "pd.usuario": "Gebruiker",

  "re.titulo": "Tellingen",
  "re.descripcion": "Wegen wat er is en vergelijken met wat er zou moeten zijn",
  "re.a": "t/m",
  "re.empezar": "+ Telling starten",
  "re.falloEmpezar": "De telling is niet gestart",
  "re.cuadra": "Klopt",
  "re.enMarcha": "Telling #{numero} loopt",
  "re.empezado": "Gestart {cuando} door {quien}. {contados} van {total} geteld.",
  "re.alguien": "iemand",
  "re.conLocalCerrado":
    "Tel met de club dicht als dat kan. Wat er ondertussen verstrekt wordt, gaat niet verloren, maar het verschil komt er schoner uit.",
  "re.seguirContando": "Verder tellen",
  "re.delPeriodo": "Tellingen in de periode",
  "re.cerrados": "Afgesloten",
  "re.todaviaNinguno": "Nog geen",
  "re.descuadreAcumulado": "Opgeteld verschil",
  "re.sumandoTodos": "Alles uit de periode bij elkaar",
  "re.elPeor": "De grootste",
  "re.elDiaQueMas": "De dag met het grootste verschil",
  "re.sinCerrados":
    "Geen afgesloten tellingen in deze periode. Tellen is bij het sluiten alles wegen en kijken of het klopt met wat het programma zegt.",
  "re.numero": "Nr.",
  "re.cuando": "Wanneer",
  "re.quien": "Wie",
  "re.contados": "Geteld",
  "re.saltados": "Overgeslagen",
  "re.descuadre": "Verschil",
  "re.seCorrigio": "Gecorrigeerd",
  "re.tardo": "Duur",
  "re.si": "Ja",
  "re.no": "Nee",
  "re.unMinuto": "1 minuut",
  "re.minutos": "{n} minuten",
  "re.ver": "Bekijken",
  "re.d.titulo": "Telling #{numero}",
  "re.d.recuento": "Telling",
  "re.d.seguirLuego": "Later verder",
  "re.d.cerrarRecuento": "Telling afsluiten",
  "re.d.contadosDe": "{contados} van {total} geteld",
  "re.d.nSaltados": " · {n} overgeslagen",
  "re.d.saltarLoQueQueda": "De rest overslaan ({n})",
  "re.d.descuadre": "Verschil:",
  "re.d.producto": "Product",
  "re.d.deberiaHaber": "Zou moeten zijn",
  "re.d.hay": "Is er",
  "re.d.saltarElResto": "De rest overslaan",
  "re.d.saltado": "Overgeslagen",
  "re.d.volverAContar": "Opnieuw tellen",
  "re.d.saltarEste": "Dit product overslaan",
  "re.d.contar": "Tellen",
  "re.d.saltar": "Overslaan",
  "re.d.notas": "Notities:",
  "re.d.seCorrigio": "Bij het afsluiten is de voorraad gecorrigeerd met wat er geteld is.",
  "re.d.noSeCorrigio": "Afgesloten zonder de voorraad te corrigeren: het verschil is alleen genoteerd.",
  "re.d.falloSaltar": "Overslaan is niet gelukt",
  "re.d.falloApuntar": "Noteren is niet gelukt",
  "re.c.titulo": "De telling afsluiten",
  "re.c.volver": "Terug",
  "re.c.cerrando": "Afsluiten...",
  "re.c.cerrar": "Afsluiten",
  "re.c.fallo": "Afsluiten is niet gelukt",
  "re.c.hasContadoUno": "Je hebt 1 product geteld en het verschil is",
  "re.c.hasContado": "Je hebt {n} producten geteld en het verschil is",
  "re.c.corregir": "De voorraad corrigeren met wat je hebt geteld",
  "re.c.corregirAyuda":
    "Het verschil wordt opgeteld bij wat er nu staat, dus als er tijdens het tellen iets verstrekt is, telt die verstrekking gewoon mee. Elke correctie laat een mutatie achter in het voorraadbeheer.",
  "re.c.notas": "Notities",
  "re.c.notasAyuda": "Bijvoorbeeld: waarom er iets ontbreekt, of wat je niet hebt bekeken.",
  "re.c.noSeBorra":
    "Een afgesloten telling wordt niet verwijderd: het is het papier dat het verschil van die dag verklaart.",

  "ct.titulo": "Catalogus",
  "ct.descripcion": "Soorten en producten die de club verstrekt",
  "ct.importar": "CSV importeren",
  "ct.marcas": "Merken",
  "ct.nuevaCategoria": "+ Categorie",
  "ct.nuevoProducto": "+ Product",
  "ct.sinProductos":
    "Er staan nog geen producten in de catalogus. De categorieën zijn er al: je hoeft alleen toe te voegen wat jullie verstrekken, met de bijdrage erbij.",
  "ct.producto": "Product",
  "ct.categoria": "Categorie",
  "ct.genetica": "Genetica",
  "ct.thcCbd": "THC / CBD",
  "ct.precio": "Bijdrage",
  "ct.stock": "Voorraad",
  "ct.estado": "Status",
  "ct.bajoMinimo": "onder minimum",
  "ct.activo": "Actief",
  "ct.inactivo": "Inactief",
  "ct.editar": "Bewerken",
  "ct.p.editar": "{nombre} bewerken",
  "ct.p.nuevo": "Nieuw product",
  "ct.p.fallo": "Het product is niet opgeslagen",
  "ct.p.nombre": "Naam",
  "ct.p.categoria": "Categorie",
  "ct.p.marca": "Merk",
  "ct.p.sinMarcasAun": "Je hebt er nog geen aangemaakt.",
  "ct.p.sinMarca": "Geen merk",
  "ct.p.genetica": "Genetica",
  "ct.p.sinEspecificar": "Niet opgegeven",
  "ct.p.thc": "THC (%)",
  "ct.p.cbd": "CBD (%)",
  "ct.p.aportacionUnidad": "Bijdrage per stuk (credits)",
  "ct.p.aportacionGramo": "Bijdrage per gram (credits)",
  "ct.p.stockMinimo": "Minimumvoorraad ({unidad})",
  "ct.p.stockMinimoAyuda": "Waarschuwt zodra het hieronder zakt.",
  "ct.p.precioPorTipo": "Vaste bijdrage per lidmaatschapsvorm",
  "ct.p.sustituye": "Vervangt die van de catalogus; de korting van de lidmaatschapsvorm komt er niet bovenop.",
  "ct.p.vacioConDescuento": "Leeg: catalogus met −{porcentaje}%",
  "ct.p.vacioCatalogo": "Leeg: catalogusbijdrage",
  "ct.p.descripcion": "Omschrijving",
  "ct.p.disponible": "Beschikbaar op de balie",
  "ct.c.titulo": "Nieuwe categorie",
  "ct.c.fallo": "Categorie aanmaken mislukt",
  "ct.c.crear": "Aanmaken",
  "ct.c.nombre": "Naam",
  "ct.c.color": "Kleur",
  "ct.c.seDispensaPor": "Verstrekt per",
  "ct.c.peso": "Gewicht (gram)",
  "ct.c.unidades": "Stuks",
  "ct.m.titulo": "Merken",
  "ct.m.listo": "Klaar",
  "ct.m.fallo": "Mislukt",
  "ct.m.ejemplo": "Cookies, Green House, eigen kweek...",
  "ct.m.anadir": "Toevoegen",
  "ct.m.sinMarcas": "Geen merken. Handig om te zien van wie elk product komt; teel je zelf, dan heb je dit niet nodig.",
  "ct.m.unProducto": "1 product",
  "ct.m.productos": "{n} producten",
  "ct.m.apagada": "Uit",
  "ct.m.apagar": "Uitzetten",
  "ct.m.encender": "Aanzetten",
  "ct.m.confirmarConProductos": "{productos} blijven zonder merk achter. Verder wordt er niets verwijderd. Doorgaan?",
  "ct.m.confirmarBorrar": "Merk «{nombre}» verwijderen?",
  "ct.m.borrar": "Verwijderen",
  "ct.m.nota":
    "Uitzetten haalt het merk uit de keuzelijst maar laat de producten die het al hebben staan. Verwijderen laat die producten zonder merk achter, meer niet.",

  "ci2.titulo": "Catalogus importeren",
  "ci2.descripcion": "Haal je producten en je voorraad uit een ander programma of uit een spreadsheet",
  "ci2.volver": "Terug",
  "ci2.importadoUno": "1 product geïmporteerd. Het staat nu in de catalogus en op de balie.",
  "ci2.importadoUnoConStock":
    "1 product geïmporteerd, met de voorraad ingeboekt als partij. Het staat nu in de catalogus en op de balie.",
  "ci2.importados": "{n} producten geïmporteerd. Ze staan nu in de catalogus en op de balie.",
  "ci2.importadosConStock":
    "{n} producten geïmporteerd, {conStock} met de voorraad ingeboekt als partij. Ze staan nu in de catalogus en op de balie.",
  "ci2.verCatalogo": "Catalogus bekijken",
  "ci2.verInventario": "Voorraadbeheer bekijken",
  "ci2.otroFichero": "Ander bestand importeren",
  "ci2.paso1": "1. Maak het bestand klaar",
  "ci2.explicacion":
    "Een CSV met één regel per product. Minimaal «Product», «Categorie» en «Prijs» (per gram, of per stuk bij de categorieën die per stuk gaan). Het begrijpt ook de namen die andere programma's gebruiken, en die in het Spaans, Catalaans, Engels en Duits: «Artikel», «Prijs», «Price», «Precio» of «Preis» werken allemaal. Staat er «Voorraad» bij, dan wordt die ingeboekt als partij, met «Inkoopprijs», «Leverancier», «Partij» en «THT» als je die erbij zet. De rest (THC, CBD, genetica, minimumvoorraad, merk, omschrijving, actief) wordt gebruikt als het erin staat.",
  "ci2.formatos":
    "De categorieën moeten al in Catalogus staan, met hun eenheid: zo maakt een typefout geen nieuwe categorie aan. Getallen met komma of met punt («8,50» of «8.5»); datums 2027-03-01 of 01/03/2027; scheidingsteken «;» of «,». Bestanden die Excel heeft opgeslagen werken ook.",
  "ci2.descargarPlantilla": "Sjabloon downloaden",
  "ci2.falloPlantilla": "Sjabloon downloaden mislukt",
  "ci2.paso2": "2. Kies het bestand en analyseer het",
  "ci2.analizarNoGuarda": "Analyseren slaat niets op: het controleert alleen het bestand en zegt je wat het vindt.",
  "ci2.analizando": "Bezig met analyseren...",
  "ci2.analizar": "Analyseren",
  "ci2.paso3": "3. Resultaat",
  "ci2.procesando": "Bestand verwerken...",
  "ci2.eligeFichero": "Kies een bestand en druk op Analyseren.",
  "ci2.filas": "Rijen",
  "ci2.validas": "Geldig",
  "ci2.conErrores": "Met fouten",
  "ci2.columnas": "Herkende kolommen: {columnas}",
  "ci2.corrige":
    "Verbeter deze rijen in het bestand en analyseer het opnieuw. Er wordt niets geïmporteerd zolang er fouten zijn.",
  "ci2.fila": "Rij",
  "ci2.problema": "Probleem",
  "ci2.producto": "Product",
  "ci2.categoria": "Categorie",
  "ci2.precio": "Bijdrage",
  "ci2.stock": "Voorraad",
  "ci2.seMuestran": "{cuantos} van {total} getoond.",
  "ci2.importarUno": "1 product importeren",
  "ci2.importarVarios": "{n} producten importeren",
  "ci2.conStock": " ({n} met voorraad)",
  "ci2.falloLeer": "Bestand lezen mislukt",
  "ci2.falloImportar": "Importeren mislukt",

  "di.titulo": "Openingsdagen",
  "di.descripcion": "Op welke dagen de club open was en hoe elke dag ging",
  "di.a": "t/m",
  "di.unDiaSinCerrar": "1 dag met een kassa die niet is afgesloten.",
  "di.diasSinCerrar": "{n} dagen met een kassa die niet is afgesloten.",
  "di.arqueoNoCuadra": "De kasopmaak van die dagen klopt pas als ze zijn afgesloten.",
  "di.irACaja": "Naar Kassa",
  "di.diasAbiertos": "Dagen open",
  "di.deTantos": "{abiertos} van {total}",
  "di.delPeriodo": "Van de gekozen periode",
  "di.entradoEnTotal": "Totaal binnengekomen",
  "di.entregasBarraCuotas": "Verstrekkingen, bar en contributies",
  "di.sociosDistintos": "Verschillende leden",
  "di.hanPasado": "Zijn in de club geweest",
  "di.soloAbiertos": "Alleen de dagen dat we open waren",
  "di.cuandoCuentaAbierto":
    "Een dag telt als open zodra iemand incheckt, er wordt verstrekt, er aan de bar wordt afgerekend of er een kassa wordt geopend.",
  "di.noAbrioNinguno": "De club is in deze periode geen enkele dag open geweest.",
  "di.sinDias": "Er zijn geen dagen in de gekozen periode.",
  "di.dia": "Dag",
  "di.socios": "Leden",
  "di.entregas": "Verstrekkingen",
  "di.dispensado": "Verstrekt",
  "di.barra": "Bar",
  "di.cuotas": "Contributies",
  "di.total": "Totaal",
  "di.caja": "Kassa",
  "di.cerrado": "Afgesloten",
  "di.unAlta": "1 inschrijving",
  "di.altas": "{n} inschrijvingen",
  "di.sinCaja": "Geen kassa",
  "di.sinCerrar": "Niet afgesloten",
  "di.cuadro": "Klopte",
  "di.notaTotal":
    "Het totaal telt verstrekkingen, bar en contributies bij elkaar op. Stortingen op het tegoed tellen niet mee, want dat geld is niet van de club, en de uitgaven gaan er niet af.",
  "di.diaYNumero": "{dia} {numero}",

  "ac.titulo": "Toegangscontrole",
  "ac.descripcion": "Registratie van leden die het pand in- en uitgaan",
  "ac.fallo": "Toegang registreren mislukt",
  "ac.registrarEntrada": "Binnenkomst registreren",
  "ac.identificar": "Lid opzoeken...",
  "ac.alElegir":
    "Kies je een lid, dan wordt zijn binnenkomst geregistreerd. Is het lidmaatschap verlopen of is het lid geschorst, dan geeft het programma een melding en wordt de toegang geweigerd.",
  "ac.socioNumero": "Lid #{numero}",
  "ac.accesoRegistrado": "Toegang geregistreerd",
  "ac.cartera": "Tegoed: {importe}",
  "ac.cuotaValida": "Lidmaatschap geldig tot {fecha}",
  "ac.irAlMostrador": "Naar de balie",
  "ac.dentroAhora": "Nu binnen",
  "ac.accesosHoy": "Registraties vandaag",
  "ac.enElLocal": "Leden in het pand",
  "ac.nadieDentro": "Er staat niemand geregistreerd in het pand.",
  "ac.desde": "sinds {hora}",
  "ac.deHoy": "Registraties van vandaag",
  "ac.ningunoHoy": "Vandaag is er nog niets geregistreerd.",
  "ac.hora": "Tijd",
  "ac.socio": "Lid",
  "ac.tipo": "Type",
  "ac.entrada": "Binnenkomst",
  "ac.salida": "Vertrek",

  "co2.titulo": "Ledencontract",
  "co2.descripcion": "De verklaring onder ede en de regels die iedereen bij de inschrijving tekent",
  "co2.fallo": "Contract opslaan mislukt",
  "co2.sinCambios": "Je hebt niets veranderd: versie {numero} blijft staan.",
  "co2.guardadoConRaros":
    "Opgeslagen als versie {numero}. Let op: {huecos} kan ik niet invullen en komt zo in het document te staan.",
  "co2.guardado": "Opgeslagen als versie {numero}.",
  "co2.sinEscribir":
    "Je hebt het contract nog niet geschreven. Zolang dat zo is, komt er bij een inschrijving niets te tekenen en ziet het lid er niets van in het ledenportaal.",
  "co2.versionActual": "Huidige versie",
  "co2.numeroVersion": "Nr. {numero}",
  "co2.publicada": "Gepubliceerd {fecha}",
  "co2.sinEscribirPie": "Nog niet geschreven",
  "co2.loHanFirmado": "Getekend door",
  "co2.contandoVersiones": "Leden, alle versies meegeteld",
  "co2.sinFirmar": "Niet getekend",
  "co2.faltanDeAlta": "Ingeschreven leden die nog moeten tekenen",
  "co2.ningunoPendiente": "Iedereen heeft getekend",
  "co2.elTexto": "De tekst",
  "co2.elTextoDeHoy": "De tekst van nu",
  "co2.ejemplo": "Verklaring onder ede\n\nOndergetekende {{NOMBRE}}, met {{DNI}}, verklaart...",
  "co2.seGuardaTalCual":
    "De tekst wordt opgeslagen zoals je hem schrijft, met de regeleinden erbij. Elke keer dat je de tekst verandert, ontstaat er een nieuwe versie; de vorige wordt niet verwijderd, want wie die heeft getekend, heeft die getekend.",
  "co2.huecos": "Invulvelden die je kunt gebruiken",
  "co2.huecosAyuda": "Zet ze tussen dubbele accolades, dan worden ze vanzelf ingevuld met de gegevens van elk lid.",
  "co2.versiones": "Versies",
  "co2.sinVersiones": "Er zijn er nog geen.",
  "co2.numero": "Nr.",
  "co2.publicadaColumna": "Gepubliceerd",
  "co2.firmas": "Handtekeningen",
  "co2.ver": "Bekijken",
  "co2.sinFirmarCuantos": "Niet getekend ({n})",
  "co2.socioColumna": "Lid",
  "co2.deAltaDesde": "Lid sinds",
  "co2.unSocioDeAntes": "1 lid van voordat het contract er was.",
  "co2.sociosDeAntes": "{n} leden van voordat het contract er was.",
  "co2.seFirmaDesde": "Tekenen kan vanaf de pagina van het lid, of vanuit het ledenportaal als ze dat gebruiken.",
  "co2.v.titulo": "Contract · versie {numero}",
  "co2.v.publicadaEl": "Gepubliceerd op {fecha}.",

  "in.titulo": "Rapporten",
  "in.descripcion": "Activiteit van de vereniging in de gekozen periode",
  "in.a": "t/m",
  "in.porDia": "Per dag",
  "in.porMes": "Per maand",
  "in.aportaciones": "Bijdragen",
  "in.unaEntrega": "1 verstrekking",
  "in.entregas": "{n} verstrekkingen",
  "in.dispensado": "Verstrekt",
  "in.cuotasCobradas": "Geïnde contributies",
  "in.unaCuota": "1 contributie",
  "in.cuotas": "{n} contributies",
  "in.gastos": "Uitgaven",
  "in.verDesglose": "Uitsplitsing bekijken",
  "in.evolucion": "Verloop van de verstrekkingen",
  "in.sinActividad": "Er is in deze periode geen activiteit geregistreerd.",
  "in.unPeriodo": "1 periode",
  "in.periodos": "{n} periodes",
  "in.masDispensados": "Meest verstrekte producten",
  "in.sinDatos": "Geen gegevens in deze periode.",
  "in.producto": "Product",
  "in.cantidad": "Hoeveelheid",
  "in.masActivos": "Meest actieve leden",
  "in.socio": "Lid",
  "in.visitas": "Bezoeken",
  "in.queMasAportan": "Wie het meest bijdraagt",
  "in.nadieHaAportado": "Niemand heeft in deze periode iets bijgedragen.",
  "in.enGenero": "{importe} aan verstrekkingen",
  "in.enBarra": "{importe} aan de bar",
  "in.deCuota": "{importe} aan contributie",
  "in.donado": "{importe} gedoneerd",
  "in.noCuentaCartera":
    "Wat ze op hun tegoed hebben gezet, telt niet mee: dat geld is nog van hen tot ze het besteden.",
  "in.porFormaDePago": "Bijdragen per betaalwijze",
  "in.recargasCartera": "Opwaarderingen van het tegoed",
  "in.queOpinan": "Wat de leden vinden",
  "in.nota": "Cijfer",
  "in.votos": "Stemmen",
  "in.queDicen": "Wat ze zeggen",
  "in.nadieHaEscrito":
    "Nog niemand heeft iets geschreven. Cijfers zonder opmerking tellen wel mee voor het gemiddelde.",

  "cm.titulo": "Community",
  "cm.descripcion": "Aanvragen voor inschrijving en nieuws voor het ledenportaal",
  "cm.nuevaNoticia": "+ Nieuwsbericht",
  "cm.tabSolicitudes": "Aanvragen",
  "cm.tabNoticias": "Nieuws",
  "cm.pendientes": "In behandeling",
  "cm.resueltas": "Afgehandeld",
  "cm.enlaceAlta": "Link om een inschrijving aan te vragen",
  "cm.copiarEnlace": "Link kopiëren",
  "cm.solicitudesPendientes": "Aanvragen in behandeling",
  "cm.sinPendientes": "Er zijn geen aanvragen in behandeling.",
  "cm.recibida": "Ontvangen",
  "cm.persona": "Persoon",
  "cm.contacto": "Contact",
  "cm.avalista": "Voorgedragen door",
  "cm.nacidoEl": "{documento} · geboren op {fecha}",
  "cm.socioNumero": "Lid nr. {numero}",
  "cm.aprobar": "Goedkeuren",
  "cm.rechazar": "Afwijzen",
  "cm.aprobada": "{persona} is nu lid nr. {numero} en moet de contributie nog betalen.",
  "cm.falloAprobar": "Goedkeuren mislukt",
  "cm.estado": "Status",
  "cm.resultado": "Resultaat",
  "cm.etiquetaAprobada": "Goedgekeurd",
  "cm.etiquetaRechazada": "Afgewezen",
  "cm.sinNoticias": "Geen nieuws. Publiceer een bericht en de leden zien het in hun portaal.",
  "cm.fecha": "Datum",
  "cm.tituloColumna": "Titel",
  "cm.publicadoPor": "Gepubliceerd door",
  "cm.publicada": "Gepubliceerd",
  "cm.borrador": "Concept",
  "cm.editar": "Bewerken",
  "cm.borrar": "Verwijderen",
  "cm.confirmarBorrar": "«{titulo}» verwijderen?",
  "cm.n.editar": "Bericht bewerken",
  "cm.n.nueva": "Nieuw bericht",
  "cm.n.fallo": "Bericht opslaan mislukt",
  "cm.n.titulo": "Titel",
  "cm.n.texto": "Tekst",
  "cm.n.textoAyuda": "De leden zien dit in hun portaal.",
  "cm.n.publicada": "Gepubliceerd (haal je het vinkje weg, dan blijft het een concept)",
  "cm.n.avisar": "Melding naar de mobiel van de leden",
  "cm.n.avisarAyuda": "Alleen leden die de meldingen in hun portaal hebben aangezet, krijgen hem.",
  "cm.n.fotos": "Foto's",
  "cm.n.quitar": "Verwijderen",
  "cm.n.subiendo": "Uploaden…",
  "cm.n.otraFoto": "Nog een foto toevoegen",
  "cm.n.anadirFotos": "Foto's toevoegen",
  "cm.n.escribePrimero":
    "Schrijf eerst de titel en de tekst: het nieuwsbericht wordt opgeslagen zodra je de eerste foto toevoegt.",
  "cm.n.hastaOcho": "Maximaal 8 foto's. JPG, PNG of WEBP.",
  "cm.n.falloSubir": "Kon de foto niet uploaden",
  "cm.n.falloQuitar": "Kon de foto niet verwijderen",
  "cm.r.titulo": "Aanvraag van {nombre} afwijzen",
  "cm.r.rechazar": "Afwijzen",
  "cm.r.fallo": "Kon niet afwijzen",
  "cm.r.queda":
    "De aanvraag wordt gearchiveerd. De reden is voor jullie eigen administratie: het programma laat het de persoon niet weten.",
  "cm.r.motivo": "Reden (optioneel)",

  "aj.titulo": "Instellingen",
  "aj.descripcion": "Gegevens van de vereniging, limieten en team",
  "aj.guardarCambios": "Wijzigingen opslaan",
  "aj.guardados": "Instellingen opgeslagen.",
  "aj.fallo": "Kon de instellingen niet opslaan",
  "aj.datos": "Gegevens van de vereniging",
  "aj.nombre": "Naam",
  "aj.cif": "CIF",
  "aj.telefono": "Telefoon",
  "aj.direccion": "Adres",
  "aj.ciudad": "Plaats",
  "aj.provincia": "Provincie",
  "aj.cp": "Postcode",
  "aj.email": "Contact-e-mail",
  "aj.reglas": "Regels voor verstrekking",
  "aj.limiteDiario": "Daglimiet (g)",
  "aj.limiteDiarioAyuda": "Per lid per dag.",
  "aj.limiteMensual": "Maandlimiet (g)",
  "aj.limiteMensualAyuda": "Per lid per kalendermaand.",
  "aj.cuotaAnual": "Jaarcontributie (credits)",
  "aj.limitesPropios": "Elk lid kan eigen limieten hebben die deze vervangen.",
  "aj.aforo": "Maximale bezetting",
  "aj.aforoAyuda":
    "Het maximale aantal personen dat naar binnen mag, volgens jullie vergunning. Staat op de balie naast het aantal mensen dat binnen is. Laat het op 0 als je het niet wilt bijhouden.",
  "aj.aforoNota":
    "Bij het bereiken van de grens komt er een melding, maar niemand wordt tegengehouden: de telling hangt ervan af dat mensen hun vertrek registreren, en een lid de deur wijzen vanwege een getal dat scheef kan zitten is erger dan helemaal geen grens.",
  "aj.ticket": "Verstrekkingsbon",
  "aj.idiomaPortal": "Taal van het ledenportaal",
  "aj.idiomaPortalAyuda":
    "De taal waarin ze het portaal zien en de contributiemails krijgen. Elk lid kan dat zelf aanpassen op de telefoon.",
  "aj.anchoPapel": "Papierbreedte",
  "aj.anchoPapelAyuda": "Die van de bonprinter op de balie.",
  "aj.ancho80": "80 mm (standaard)",
  "aj.ancho58": "58 mm (smal)",
  "aj.textoTicket": "Tekst op de bon",
  "aj.textoTicketAyuda": "Komt onderaan elke verstrekking.",
  "aj.avisoLegal": "Juridische kennisgeving",
  "aj.avisoCuota": "Automatische contributiemelding",
  "aj.avisoCuotaNota":
    "Eén keer per dag stuurt het programma een melding per e-mail (en naar de telefoon, als ze het portaal hebben geïnstalleerd) aan de leden van wie het lidmaatschap verloopt. Elk lid krijgt maar één melding per contributieperiode: na verlenging komt het lid het jaar daarna weer aan de beurt.",
  "aj.avisarAuto": "Automatisch melden",
  "aj.cuantosDiasAntes": "Hoeveel dagen van tevoren",
  "aj.cuantosDiasAyuda": "Leden bij wie het lidmaatschap al verlopen is, krijgen ook een melding.",
  "aj.avisoApagado":
    "Staat met opzet uit: jullie leden mailen is een keuze van de club, niet van het programma. Via Verlengingen kunnen jullie ze altijd met de hand versturen, ook als dit uit blijft staan.",
  "aj.equipo": "Team",
  "aj.nuevoUsuario": "+ Gebruiker",
  "aj.usuario": "Gebruiker",
  "aj.rol": "Rol",
  "aj.ultimoAcceso": "Laatst ingelogd",
  "aj.desactivado": "Gedeactiveerd",
  "aj.nunca": "Nooit",
  "aj.permisosAMedida": "aangepaste rechten",

  "permiso.verSocios": "Ledenregister bekijken",
  "permiso.crearSocio": "Leden inschrijven",
  "permiso.editarSocio": "Gegevens van een lid bewerken",
  "permiso.registrarAcceso": "Binnenkomst registreren",
  "permiso.dispensar": "Verstrekken aan de balie",
  "permiso.cobrarCuota": "Contributies innen",
  "permiso.recargarCartera": "Tegoed van een lid opwaarderen",
  "permiso.verCatalogo": "Catalogus bekijken",
  "permiso.venderBarra": "Afrekenen aan de bar",
  "permiso.gestionarInventario": "Ontvangsten, derving en tellingen",
  "permiso.anularDispensacion": "Verstrekkingen annuleren",
  "permiso.suspenderSocio": "Leden tijdelijk schorsen",
  "permiso.gestionarCaja": "Kassa openen en afsluiten",
  "permiso.gestionarGastos": "Uitgaven, inkopen en donaties boeken",
  "permiso.descuentoManual": "Handmatige korting geven aan de balie",
  "permiso.moverGuardado": "Van het magazijn naar de balie halen",
  "permiso.verInformes": "Rapporten bekijken en exporteren",
  "permiso.ajustarCartera": "Saldo terugbetalen of corrigeren",
  "permiso.gestionarPublicaciones": "Nieuws publiceren",
  "permiso.gestionarSolicitudes": "Inschrijvingsaanvragen afhandelen",
  "permiso.gestionarCatalogo": "Producten aanmaken en bewerken",
  "permiso.gestionarBarra": "Barkaart beheren",
  "permiso.anularCuota": "Geïnde contributies annuleren",
  "permiso.gestionarUsuarios": "Team beheren",
  "permiso.ajustesClub": "Instellingen van de club wijzigen",
  "permiso.bajaSocio": "Leden uitschrijven",
  "permiso.importarSocios": "Leden importeren uit CSV",
  "permiso.importarProductos": "Catalogus en voorraad importeren uit CSV",
  "permiso.verAuditoria": "Logboek bekijken",
  "permiso.borrarDatos": "Gegevens van een lid wissen",
  "permiso.copiaSeguridad": "Back-ups downloaden",

  "aj.cs.titulo": "Alle gebruikers uitloggen",
  "aj.cs.explicacion":
    "Hiermee log je het hele team op alle schermen uit, jezelf ook. Gaat het maar om één iemand, dan hoeft dit niet: deactiveer hierboven dat account, dan komt diegene er net zo goed niet meer in.",
  "aj.cs.boton": "Het hele team uitloggen",
  "aj.cs.queVaAPasar":
    "Elk scherm dat openstaat vraagt opnieuw om het wachtwoord zodra het weer contact zoekt met de server, binnen een paar seconden. Ook dat van jou.",
  "aj.cs.loPendiente":
    "Al afgerekende verstrekkingen die nog niet verstuurd zijn, gaan niet verloren: ze blijven op de tablet staan en worden vanzelf verstuurd zodra iemand weer inlogt.",
  "aj.cs.confirmar": "Het hele team uitloggen",
  "aj.cs.cerrando": "Uitloggen…",
  "aj.cs.fallo": "Kon het team niet uitloggen",
  "aj.editar": "Bewerken",
  "aj.tiposDeSocio": "Lidmaatschapsvormen",
  "aj.nuevoTipo": "+ Vorm",
  "aj.sinTipos": "Nog geen vormen. Maak er bijvoorbeeld een aan met «Steunlid», 10% korting en een lagere contributie.",
  "aj.tipo": "Vorm",
  "aj.descuento": "Korting",
  "aj.cuota": "Contributie",
  "aj.dura": "Duur",
  "aj.limites": "Limieten",
  "aj.socios": "Leden",
  "aj.laDelClub": "die van de club",
  "aj.losDelClub": "die van de club",
  "aj.limitesDiaMes": "{diario} / dag · {mensual} / maand",
  "aj.registro": "Logboek",
  "aj.sinRegistros": "Nog niets geregistreerd.",
  "aj.sistema": "systeem",
  "aj.copia": "Back-up",
  "aj.copiaNota":
    "Download de gegevens en bewaar ze versleuteld buiten het pand. De foto's van de leden staan in de map «uploads» op de server en zitten er niet bij.",
  "aj.copiaDatos": "Gegevens van de club (JSON)",
  "aj.copiaBase": "Volledige database (.db)",
  "aj.falloCopia": "Kon de back-up niet downloaden",
  "aj.variosClubes": "Op deze installatie staan meerdere clubs: de volledige back-up van de server maakt de beheerder.",
  "aj.copiasAuto": "Automatische back-ups",
  "aj.copiasAutoNota": "Het programma maakt elke nacht een back-up en bewaart die van de laatste 14 dagen.",
  "aj.sinCopiasAun":
    "Er is er nog geen: de eerste wordt vannacht gemaakt. Bewaar er zelf toch ook af en toe een buiten de server.",
  "aj.u.titulo": "Nieuwe gebruiker voor het team",
  "aj.u.fallo": "Kon de gebruiker niet aanmaken",
  "aj.u.crear": "Aanmaken",
  "aj.u.nombre": "Naam",
  "aj.u.email": "E-mail",
  "aj.u.contrasena": "Wachtwoord",
  "aj.u.minimo": "Minimaal 8 tekens.",
  "aj.u.rol": "Rol",
  "aj.u.trabajadorLargo": "Medewerker — het dagelijkse werk: balie, leden, voorraadbeheer en kassa",
  "aj.e.titulo": "{nombre} bewerken",
  "aj.e.fallo": "Kon de gebruiker niet opslaan",
  "aj.e.nombre": "Naam",
  "aj.e.rol": "Rol",
  "aj.e.puesto": "Werkplek",
  "aj.e.puestoAyuda":
    "Bepaalt in welke kassa het geld komt dat deze persoon int. Zonder werkplek: in de kassa van de club.",
  "aj.e.sinPuesto": "Geen werkplek",
  "aj.e.nuevaContrasena": "Nieuw wachtwoord",
  "aj.e.nuevaContrasenaAyuda": "Laat leeg om het niet te wijzigen. Minimaal 8 tekens.",
  "aj.e.cuentaActiva": "Account actief",
  "aj.e.noTuPropia": "Je kunt je eigen account niet deactiveren.",
  "aj.e.desactivada": "Een gedeactiveerd account kan niet inloggen, maar de geschiedenis blijft bewaard.",
  "aj.e.permisos": "Rechten",
  "aj.e.permisosAyuda":
    "De rol bepaalt standaard wat iemand mag. Hier kun je uitzonderingen maken voor deze persoon: wat je wijzigt wordt gemarkeerd.",
  "aj.e.concedido": "toegekend",
  "aj.e.retirado": "ingetrokken",
  "aj.e.volverAlRol": "Terug naar de rechten van de rol",
  "aj.t.editar": "{nombre} bewerken",
  "aj.t.nuevo": "Nieuwe lidmaatschapsvorm",
  "aj.t.fallo": "Kon de vorm niet opslaan",
  "aj.t.falloBorrar": "Kon de vorm niet verwijderen",
  "aj.t.borrar": "Verwijderen",
  "aj.t.nombre": "Naam",
  "aj.t.color": "Kleur",
  "aj.t.descripcion": "Omschrijving",
  "aj.t.descuento": "Algemene korting (%)",
  "aj.t.descuentoAyuda": "Op de catalogusbijdrage, tenzij het product een vaste bijdrage heeft voor deze vorm.",
  "aj.t.cuota": "Jaarcontributie (credits)",
  "aj.t.cuotaAyuda": "Leeg = de contributie van de club. 0 = geen contributie.",
  "aj.t.duracion": "Hoelang die duurt (maanden)",
  "aj.t.duracionAyuda": "12 is het gebruikelijke. Met 1 betaalt het lid elke maand.",
  "aj.t.limiteDiario": "Daglimiet (g)",
  "aj.t.limiteDiarioAyuda": "Leeg = die van de club.",
  "aj.t.limiteMensual": "Maandlimiet (g)",
  "aj.t.orden": "Volgorde",
  "aj.t.activo": "Actief (kan aan nieuwe leden worden toegewezen)",
  "aj.p.titulo": "Werkplekken",
  "aj.p.nota":
    "Als er in de club op meer dan één plek tegelijk wordt geïnd — de balie en de bar, elk met een eigen lade — maak dan voor elke plek een werkplek aan en wijs bij Team iedere medewerker de zijne toe. Elke werkplek opent en maakt zijn eigen kassa op.",
  "aj.p.nota2": "Als je er geen aanmaakt, blijft alles zoals het was: één kassa voor de hele club.",
  "aj.p.inactivo": " · inactief",
  "aj.p.unaPersona": "1 persoon",
  "aj.p.personas": "{n} personen",
  "aj.p.desactivar": "Deactiveren",
  "aj.p.activar": "Activeren",
  "aj.p.falloCambiar": "Kon niet wijzigen",
  "aj.p.ejemplo": "Balie, Bar...",
  "aj.p.anadir": "Toevoegen",
  "aj.p.fallo": "Kon de werkplek niet aanmaken",

  "su.titulo": "Je abonnement",
  "su.prueba": "In proefperiode",
  "su.pruebaCaducada": "Proefperiode afgelopen",
  "su.alDia": "Betaald",
  "su.moroso": "Openstaande betaling",
  "su.suspendido": "Geschorst",
  "su.sinCoste": "Gratis",
  "su.alMes": "{importe} per maand",
  "su.sinCuota": "Voor deze club is er geen abonnementsgeld: je kunt het programma gebruiken zonder iets te betalen.",
  "su.bloqueado":
    "Het abonnement staat al {dias} open en het programma is alleen-lezen. Jullie kunnen alles bekijken en de back-ups downloaden; zodra de betaling binnen is, werkt alles weer.",
  "su.vencioAyer": "Gisteren verlopen. Voorlopig werkt alles gewoon door.",
  "su.vencioHace": "{dias} geleden verlopen. Voorlopig werkt alles gewoon door.",
  "su.pruebaTermina": "De proefperiode eindigt op {fecha}, {cuando}.",
  "su.periodoHasta": "De betaalde periode loopt tot {fecha}, {cuando}.",
  "su.hoy": "vandaag",
  "su.manana": "morgen",
  "su.enDias": "over {dias}",
  "su.sinFecha": "Er staat geen einddatum geregistreerd.",
  "su.pagos": "Geregistreerde betalingen",
  "su.sinPagos": "Er is nog geen betaling geregistreerd.",
  "su.fecha": "Datum",
  "su.importe": "Bedrag",
  "su.cubreHasta": "Dekt tot",
  "su.forma": "Betaalwijze",
  "su.recibo": "Betalingsbewijs",
  "su.metodo.TRANSFERENCIA": "Overboeking",
  "su.metodo.EFECTIVO": "Contant",
  "su.metodo.DOMICILIACION": "Automatische incasso",
  "su.metodo.TARJETA": "Pin",
  "su.metodo.OTRO": "Anders",
  "su.r.imprimir": "Afdrukken of opslaan als PDF",
  "su.r.suscripcion": "Abonnement op het beheerprogramma",
  "su.r.recibidoDe": "Ontvangen van",
  "su.r.fechaDelPago": "Datum van de betaling",
  "su.r.concepto": "Omschrijving",
  "su.r.conceptoTexto": "Abonnement op het beheerprogramma, tot {fecha}",
  "su.r.formaDePago": "Betaalwijze",
  "su.r.importe": "Bedrag",
  "su.r.justificante":
    "Bewijs van de geregistreerde betaling. Dit vervangt de factuur niet; die wordt opgemaakt door wie de dienst levert.",

  "en.titulo": "Clubbeheer",
  "en.subtitulo": "Log in met je teamaccount",
  "en.email": "E-mail",
  "en.contrasena": "Wachtwoord",
  "en.club": "Club",
  "en.eligeClub": "Kies de club...",
  "en.variosClubes": "Dit e-mailadres hoort bij meerdere clubs: kies er een.",
  "en.entrando": "Bezig met inloggen...",
  "en.cola.una":
    "Op deze tablet staat nog één verstrekking die niet verstuurd is: die is zonder verbinding gedaan en gaat eruit zodra je inlogt.",
  "en.cola.varias":
    "Op deze tablet staan er nog {cuantas} die niet verstuurd zijn: ze zijn zonder verbinding gedaan en gaan eruit zodra je inlogt.",
  "en.entrar": "Inloggen",
  "en.fallo": "Kon niet inloggen",
  "en.olvidada": "Ik ben mijn wachtwoord vergeten",
  "en.aunNoEsta": "Staat jullie club er nog niet bij?",
  "en.darloDeAlta": "Inschrijven",
  "en.queEs": "Wat is asocis",

  "rc.titulo": "Ik ben mijn wachtwoord vergeten",
  "rc.subtitulo": "We sturen je een link naar het e-mailadres van je account",
  "rc.email": "E-mail",
  "rc.enviando": "Bezig met versturen...",
  "rc.enviar": "Stuur me de link",
  "rc.fallo": "Kon de e-mail niet versturen",
  "rc.miraSpam": "Kijk ook in je map met ongewenste e-mail. De link verloopt over een uur.",
  "rc.volver": "Terug naar inloggen",
  "rc.nueva": "Nieuw wachtwoord",
  "rc.cambiada": "Wachtwoord gewijzigd. We brengen je naar het inloggen...",
  "rc.entrarAhora": "Nu inloggen",
  "rc.nuevaEtiqueta": "Nieuw wachtwoord",
  "rc.minimo": "Minimaal 8 tekens.",
  "rc.repitela": "Herhaal het",
  "rc.noCoinciden": "De twee wachtwoorden komen niet overeen.",
  "rc.cambiar": "Wachtwoord wijzigen",
  "rc.falloCambiar": "Het wachtwoord kon niet worden gewijzigd",

  "rg.cerrado": "Inschrijving van clubs gesloten",
  "rg.cerradoTexto":
    "Op deze installatie kun je geen nieuwe clubs aanmaken via het web. Vraag de beheerder van de server om toegang.",
  "rg.volverAEntrar": "Terug naar inloggen",
  "rg.titulo": "Een club inschrijven",
  "rg.subtitulo": "Je maakt de vereniging en je eigenaarsaccount aan",
  "rg.nombreClub": "Naam van de vereniging",
  "rg.nombreClubEjemplo": "Cannabisvereniging...",
  "rg.ciudad": "Plaats",
  "rg.tuNombre": "Je naam",
  "rg.tuEmail": "Je e-mailadres",
  "rg.tuEmailAyuda": "Hiermee log je straks in.",
  "rg.contrasena": "Wachtwoord",
  "rg.minimo": "Minimaal 8 tekens.",
  "rg.repite": "Herhaal het wachtwoord",
  "rg.codigo": "Licentiecode",
  "rg.codigoAyuda": "Die je kreeg toen je het abonnement afsloot. Ziet er zo uit: ASOC-XXXX-XXXX.",
  "rg.acepto": "Ik ga akkoord met de",
  "rg.avisoLegal": "juridische kennisgeving",
  "rg.yLa": "en de",
  "rg.privacidad": "privacybeleid",
  "rg.creando": "De club wordt aangemaakt...",
  "rg.crear": "Club aanmaken",
  "rg.yaTeneis": "Hebben jullie al een club?",
  "rg.entrar": "Inloggen",
  "rg.noCoinciden": "De twee wachtwoorden komen niet overeen",
  "rg.fallo": "Kon de club niet aanmaken",
};
